$(function(){
  
    externalLinkNewTab();
    initFlickityTestimony();
    jscOnloadColorSwatch();
    onloadSizeGuideTable();
    onloadDisplaySizeGuide();
    initFlickityBlogTabs();
    initMobileNavSlider();
    onloadBedBuilder();
    onloadLoungewearSet();
    onloadjscBlog();
    onloadBundlePrice();
    onloadRedirectPages();
    onLoadToggleMessageBox();
    onLoadUpdateCharacterCount();
    onloadimgswap();
    onloadScrollSection();
    setStoreLanguageClass();
    
    if (location.href.includes('/account')) {
      onloadYotpoRedeem();
    }

    setTimeout(function(){

      cartDrawerUpt();
      onloadRewardsPage();
      // onloadCartClear();
    },500);

    if (location.href.includes('/products')) {
      onloadBISbutton();
      hidePDPReview();
      klaviyoStarStyling();
    }
    if (location.href.includes('bundle-set') || location.href.includes('sheet-set') || location.href.includes('duvet-set') || location.href.includes('quilt-set')) {
      onloadjscBundleSet();
      // console.log('smooth');
    }

    if (location.href.includes('/cart')) {
      jscClearCartAttr();
    }
    setTimeout(function(){
      sessionStorage.clear();
    },5000);

    // masterPromo(false);
    document.addEventListener('cart:updated', function(evt) {
      masterPromo(false);
    });
    $(document).on('cart.requestComplete', function(event, cart) {
      document.dispatchEvent(new CustomEvent('cart:build'));
      setTimeout(function(){
        if ($('.cart__items[data-count="0"]').length > 0) {
          location.reload();
        }
      },1000);
    });
    document.addEventListener('ajaxProduct:added', function(evt) {
      masterPromo(false);
    });
    
});

masterPromo = (isDrawer) =>{
  setTimeout(function(){
    cartGift();
  },1000);
}
//get current data and time
var $cur_Date = new Date();
var $date_time = $cur_Date.getDate() + "/"
              + ($cur_Date.getMonth()+1)  + "/"
              + $cur_Date.getFullYear() + ","
              + $cur_Date.getHours() + ":"
              + $cur_Date.getMinutes() + ":"
              + $cur_Date.getSeconds();


cartDrawerUpt = () => {
  $(document).on('cart.requestStarted', function(event, cart) {
    var $html = `<div class="jsc-page-loading">
                  <div class="jsc-spinner-container">
                    <div class="jsc-spinner"></div>
                  </div>
                </div>`;
    $('body').prepend($html);
  });
  $(document).on('cart.requestComplete', function(event, cart) {
    $('.jsc-page-loading').remove();
    setTimeout(function(){ 
      location.reload();
      console.log('after reload');
    },1000);

  });
}

cartJSAddQuery = (vid, qty, obj) => {
    // Cart js add item, success callback, error callback
  
    CartJS.addItem(vid, qty, obj,
    {
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {
        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          beforeSend: function() {
            console.log('before');
            // to call theme cart

          },
          success: function(cart) {
            /*
            getThis.element.dispatchEvent(new CustomEvent('product:added', {
              bubbles: isOpenDrawer,
              detail: {
                variant: vid,
                quantity: qty
              }
            }));
            */
          }
        });
      },
      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown);
      }
    });
}
  
cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer) => {
    // Cart js add item, success callback, error callback
  
    CartJS.updateItemById(vid, qty, obj,
    {
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {
        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          beforeSend: function() {
            console.log('before');
          },
          success: function(cart) {
            /*
            getThis.element.dispatchEvent(new CustomEvent('product:added', {
              bubbles: isOpenDrawer,
              detail: {
                variant: vid,
                quantity: qty
              }
            }));
            */
          }
        });
      },
      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown);
      }
    });
}
cartJSRemoveItem = (index) => {

  CartJS.removeItem(index,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('remove item1',index);
          // to call theme cart

        }
      });
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });

}
cartJSUpdateItem = (index, qty, obj, isOpenDrawer) => {
  // Cart js add item, success callback, error callback

  CartJS.updateItem(index, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('before');
        }
      });
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}

initFlickityTestimony = () => {
    var timesRun = 0;
    var countGrid = 0;
    var timer = setInterval(function() {

    if ($('.jsc-testimony-flickity').length > 0 ) {

            var flkty = new Flickity( '.jsc-testimony-flickity' , {
            // options
            cellAlign: 'center',
            contain: false,
            pageDots: true,
            groupCells: true,
            wrapAround: true,
            draggable: true,
            prevNextButtons: false,
            autoPlay: 4000,
            on: {
                ready: function() {
                $(this.element).addClass('jsc-flickity-initiated');
                }
            }
            });
        

        }


        clearInterval(timer);
    })
}

var $pricing_format = $('.jsc-store-routes').attr('data-pricing-format');
var $pricing_hide_cents = $('.jsc-store-routes').attr('data-hide-cents');

//START: pdp update bundle color swatch
jscOnloadColorSwatch = () => {
    var colorSelected = $('.jsc-select').attr('data-size');
    var colorDiv = $('.jsc-color-div');
    
    colorDiv.each(function() {
        
        var $this = $(this);
        var colorDivID = $this.attr('data-size');
        // console.log(colorDivID);
        $this.hide();
        
        if (colorSelected == colorDivID) {
            $this.show();
            $this.addClass('jsc-active-size');
        }
        
    });

    // console.log($('.jsc-input-id').attr('data-img'));
}
jscUpdateColorSwatch = (e,color) => {
    
    var colorDiv = $('.jsc-color-div');
    var swatchMainDiv = $('.jsc-colorSwatch').find('.extra-property');
    var productImageDiv = $('.jsc-product-gallery-media');
    var productImageData = $('.jsc-input-id').attr('data-img');
    var bundleSize = $(e).val();
    var bundleVariant = $('.jsc-bundle-variant');
    
    colorDiv.each(function() {
        
        var $this = $(this);
        var colorDivID = $this.attr('data-size');
        // console.log(colorDivID);
        $this.hide();
        $this.find('.active').removeClass('active');
        $this.find('.show-error').removeClass('show-error');
        $this.removeClass('jsc-active-size');
        
        if (color == colorDivID) {
            $this.show();
            $this.addClass('jsc-active-size');
            $this.find('.swatch-set-display').html("");
        }
        
    });
    swatchMainDiv.each(function() {
        
        var $_this = $(this);
        $_this.attr("value","");
        
    });

    //to update bundle size details
    bundleVariant.attr('data-size',bundleSize);

    //to remove the content of jsc product image div
    productImageDiv.find('.jsc-overlay-var-img').remove();
    console.log();

    //start: 'Bundle Contains' section
    var $bundle_contains_section = $('.jsc-bundle-contains-div');
    if ($bundle_contains_section.length > 0) {
      $bundle_contains_section.children().each(function(){
        // console.log($(this));
        var $this_var_title = $(this).attr('data-var-title');

        $(this).addClass('inactive-variant');
        $(this).removeClass('active-variant');
        if ($this_var_title == color) {
          $(this).removeClass('inactive-variant');
          $(this).addClass('active-variant');
        }
      });
    }
    //end: 'Bundle Contains' section
    
}
jscUpdateColorSwatchThis = (e,size,selectedSize,identifier) => {
  var $thisValue = $(e).val();
  var $productSet;
  $(e).parents('.jsc-bundle-main').find('.extra-error').removeClass('show-error');
  

  $productSet = $(e).parents('body').find('.product-form-set'); //using bigger parent because mobile dropdown behaves differently
  
  $productSet.each(function(){
    var $_thisSet = $(this);
    var $_thisSetInput = $_thisSet.find('.jsc-bundle-variant-hidden');
    var $_thisSetIdentifier = $_thisSetInput.attr('data-unique');
    var $_thisSetColors = $_thisSet.find('.jsc-variant-info');
    var $_thisSetText = $_thisSet.find('.jsc-swatch-text-single');

    $_thisSetColors.removeClass('active-colors');
    

    if (identifier == $_thisSetIdentifier) {
      $_thisSetInput.attr('data-id','');
      $_thisSetInput.attr('data-var-avail','');
      $_thisSetInput.attr('data-color','');
      $_thisSetInput.attr('data-size','');
      $_thisSetInput.attr('data-price','');
      $_thisSetText.find('span').html('');
      
      $_thisSetInput.attr('data-size',$thisValue);
      $_thisSetColors.find('.jsc-bundle-dummy-style').removeClass('bundle-active');

      $_thisSetColors.each(function(){
        var $this = $(this);
        var thisSize = $this.attr('data-size');
        $this.hide();
        $this.removeClass('active');
        if (thisSize == $thisValue) {
          $this.show();
          $this.removeClass('hide-color');
          $this.css('display','flex');
          $this.addClass('active-colors');
        }
      });
    }
    
  });
  
}
jscRecordColorSwatch = (e,title,color,varImg) => {
    var $this = $(e);
    var colorList = $this.parents('.product-form-variants-each').find('.variant-color-con');
    var swatchMainDiv = $this.parents('.jsc-colorSwatch').find('.extra-property');
    
    
    colorList.each(function() {
        
        var $_this = $(this);
        var color_list = $_this.attr('data-color');
        
        $_this.removeClass('active');
        
        if (color == color_list) {
            $this.parent().addClass('active');
            $this.parents('.product-form-variants-each').siblings('.option_title').find('.swatch-set-display').html(color);
            $this.parents('.product-form-variants-each').siblings('.show-error').removeClass('show-error');
        }
        
    });
    swatchMainDiv.each(function() {
        
        var $_this = $(this);
        var $item = $_this.attr('data-name');
        
        if ($item == title) {
            $_this.attr("value",color);
        }
        
    });
    
    
    //to append product image
    var $productImage = $('.jsc-product-gallery-media');
    $productImage.find('.jsc-overlay-var-img').each(function(){
      var $this_data = $(this).attr('data-type');
      if ($this_data == title) {
        $(this).remove();
      }
    });
    
    $productImage.append('<img class="jsc-overlay-var-img" src="'+varImg+'" data-type="'+title+'" >');
    
}
onHoverSwatchText = (e,col) => {
  if ($(window).width() > 1024) {
    var $this = $(e);
    // start: mix match product
    var $textDiv = $this.parents('.product-form-variants-each').siblings('.option_title');
    $textDiv.find('.swatch-set-display2').html(col);
    $textDiv.find('.swatch-set-display2').show();
    $textDiv.find('.swatch-set-display').hide();
    // end: mix match product

    // start: 1 variant product
    var $singletextDiv = $this.parents('.product-form-set').find('.jsc-swatch-text-single');
    $singletextDiv.find('.swatch-display2').html(col);
    $singletextDiv.find('.swatch-display2').show();
    $singletextDiv.find('.swatch-display').hide();
    $this.find('.jsc-bundle-dummy-style').addClass('bundle-hover');
    
    // end: 1 variant product

    // start: bed builder product
    var $bbDiv =  $this.parents('.jsc-section-content').find('.jsc-container-selected-color');
    $bbDiv.find('.jsc-hover-color-title').html(col);
    $bbDiv.find('.jsc-hover-color-title').show();
    $bbDiv.find('.jsc-selected-color-title').hide();
    // end: bed builder product

    // start: bed builder product (display next to section title)
    var $bbTitleDiv =  $this.parents('.jsc-section-bb').find('.jsc-section-title-div .jsc-container-selected-color');
    $bbTitleDiv.find('.jsc-hover-color-title').html(col);
    $bbTitleDiv.find('.jsc-hover-color-title').show();
    $bbTitleDiv.find('.jsc-selected-color-title').hide();
    // end: bed builder product (display next to section title)

    // start: 2 variant option product
    var $2varDiv =  $this.parents('.variant-picker__option').find('.variant-picker__option-info');
    $2varDiv.find('.jsc-hovered-swatch').html(col);
    $2varDiv.find('.jsc-hovered-swatch').show();
    $2varDiv.find('.jsc-selected-var').hide();
    // end: 2 variant option product
  }
}
  
outHoverSwatchText = (e) => {
  if ($(window).width() > 1024) {
    var $this = $(e);
    // start: mix match product
    var $textDiv = $this.parents('.product-form-variants-each').siblings('.option_title');
    $textDiv.find('.swatch-set-display2').hide();
    $textDiv.find('.swatch-set-display').show();
    // end: mix match product

    // start: 1 variant product
    var $singletextDiv = $this.parents('.product-form-set').find('.jsc-swatch-text-single');
    $singletextDiv.find('.swatch-display2').hide();
    $singletextDiv.find('.swatch-display').show();
    $this.find('.jsc-bundle-dummy-style').removeClass('bundle-hover');
    // end: 1 variant product

    // start: bed builder product
    var $bbDiv =  $this.parents('.jsc-section-content').find('.jsc-container-selected-color');
    $bbDiv.find('.jsc-hover-color-title').hide();
    $bbDiv.find('.jsc-selected-color-title').show();
    // end: bed builder product

    // start: bed builder product (display next to section title)
    var $bbTitleDiv =  $this.parents('.jsc-section-bb').find('.jsc-section-title-div .jsc-container-selected-color');
    $bbTitleDiv.find('.jsc-hover-color-title').hide();
    $bbTitleDiv.find('.jsc-selected-color-title').show();
    // end: bed builder product (display next to section title)

    // start: 2 variant option product
    var $2varDiv =  $this.parents('.variant-picker__option').find('.variant-picker__option-info');
    $2varDiv.find('.jsc-hovered-swatch').html('');
    $2varDiv.find('.jsc-hovered-swatch').hide();
    $2varDiv.find('.jsc-selected-var').show();
    // end: 2 variant option product
  }
}

jscRecordBundleSwatch = (e,color,varID,varAvail,price) => {
  var $this = $(e);
  var $singletextDiv = $this.parents('.product-form-set').find('.jsc-swatch-output');
  $singletextDiv.find('.swatch-display').html(color);
  var $colorList = $this.parents('.main-colors').find('.variant-color-con');
  var $bundleDiv = $('.jsc-bundle-main');
  var $variantInput = $bundleDiv.find('.jsc-all-variant');
  var $totalBundle = 0;

  $colorList.each(function() {
    var $_this = $(this);
    var $dataColor = $_this.attr('data-color');
    $_this.removeClass('active');
    var $thisItemDetails = $_this.parents('.product-form-set').find('.jsc-swatch-output  .jsc-bundle-variant');
    
    if ($dataColor == color) {
      $_this.addClass('active');
      $thisItemDetails.attr('data-color',color);
      var $colorSelected = $thisItemDetails.attr('data-color');
      var $sizeSelected = $thisItemDetails.attr('data-size');

      $variantInput.each(function(){ // to match the Size and Color to get variant id
        var $this = $(this);
        var $thisSize = $this.attr('data-size');
        var $thisColor = $this.attr('data-color');
        var $thisVarID = $this.attr('data-id');

        if ($thisColor == $colorSelected && $thisSize == $sizeSelected) {
          $thisItemDetails.attr('data-id',$thisVarID);
        }

      });
    }
    
  });
  
  var jscBundleForm = $this.parents('.product-form-set.jsc-bundle-form');
  jscBundleForm.find('.jsc-bundle-variant-hidden').attr('data-color',color);
  jscBundleForm.find('.jsc-bundle-variant-hidden').attr('data-id',varID);
  jscBundleForm.find('.jsc-bundle-variant-hidden').attr('data-var-avail',varAvail);
  jscBundleForm.find('.jsc-bundle-variant-hidden').attr('data-price',price);
  $this.addClass('active');
  $this.siblings().removeClass('active');
  $this.find('.jsc-bundle-dummy-style').addClass('bundle-active');
  $this.siblings().find('.jsc-bundle-dummy-style').removeClass('bundle-active');
  jscBundleForm.find('.extra-error').removeClass('show-error');

  //start: calculate total price
  $('.product-form-set .jsc-bundle-variant-hidden').each(function(){
    var $price = $(this).attr('data-price');
    var $priceInt = parseInt($price);
    if ($price != '') {
    $totalBundle += $priceInt;
    }
  });
  console.log($totalBundle,'total');
  // var format_totalbundle = Shopify.formatMoney($totalBundle, $('body').data('money'));
  // $('.jsc-bb-price-details').attr('data-main-price-discounted',format_totalbundle);
  //end: calculate total price

  // console.log(color,varID);
}
//END: pdp update bundle color swatch

jscATC = () => {
    var jscColorSwatch = $('.jsc-colorSwatch');
    var jscActiveSize = $('.jsc-colorSwatch .jsc-active-size');
    var jscActiveSizeColor = $('.jsc-colorSwatch .jsc-active-size .main-swatches');
    var countType = 0;
    var countSelectedType = 0;
    var $obj = {};
    var $vid = $('.shopify-product-form .jsc-input-id').val();

    if (jscColorSwatch.length > 0) {
        var swatchInput = jscColorSwatch.find('.extra-property');
        swatchInput.each(function() {
        
            var $_this = $(this);
            var dataTitle = $_this.attr('data-name');
            var dataColor = $_this.attr('value');
            countType += 1;
            $obj[dataTitle] = dataColor;

            if (dataColor == '') {
                console.log('missing',dataTitle);
                jscActiveSizeColor.each(function() {
                    var $thisType = $(this);
                    if ($thisType.find('.active').length == 0) {
                        $thisType.find('.extra-error').addClass('show-error');
                    }
                    
                });              
                
            } else {
                countSelectedType += 1;
                console.log('selected',dataTitle,dataColor);
            }            
            
        });

        // console.log(countType,countSelectedType);
        if (countSelectedType == countType) {
            // console.log($vid);
            cartJSAddQuery($vid,1,$obj,true);
            setTimeout(function() {
                location.reload();
            },1000);
        }
        
    }
}

jscBundleATC = (e,set,url,prodID,excludeBundle) => {

  var title = $(e).siblings('.jsc-get-prodtitle').attr('data-title');
  var en_title = $(e).siblings('.jsc-get-prodtitle').attr('data-en-title');
  var th_title = $(e).siblings('.jsc-get-prodtitle').attr('data-th-title');
  var $bundleDiv = $('.jsc-bundle-main');
  var $eachProduct = $bundleDiv.find('.product-form-set.jsc-bundle-form');
  var $loopLimit = $bundleDiv.find('.jsc-item-limit').attr('data-limit');
  var $mainDiscounted = $(e).parents('.product-info').find('.jsc-bb-price-details').attr('data-main-price-discounted');
  var countSelectedType = 0;
  var countLoop = 0;
  var $totalItem = $('.jsc-item-limit').attr('data-limit');
  var $obj = {};
  var $objMain = {};
  var $bindID = set + ',' + $date_time;
  var discountvalue = $('.jsc-bundle-discount').attr('data-discount');
  $obj['_Quantity-Promo'] = 'percentage-off-bundle';
  $obj['_Off-Value'] = discountvalue;
  $obj['_BindID'] = $bindID;
  $obj['_Total-Item'] = $totalItem;
  $objMain['_Quantity-Promo'] = 'percentage-off-bundle';
  $objMain['_Off-Value'] = discountvalue;
  $objMain['_BindID'] = $bindID;
  $objMain['_MainProduct'] = true;
  $objMain['_DummyProduct'] = title;
  $objMain['_DummyProductUrl'] = url;
  $objMain['_BundlePrice'] = $mainDiscounted;
  $objMain['_Total-Item'] = $totalItem;
  $objMain['_DummyProductID'] = prodID;
  $objMain['_ExcludeBundle'] = excludeBundle;
  console.log($totalItem)

  if (en_title != '' && th_title != '') {
    var $en_title = en_title.replace('en-title_', '');
    var $th_title = th_title.replace('th-title_', '');
    $objMain['_En-Title'] = $en_title;
    $objMain['_Th-Title'] = $th_title;
  }

  //start: to calculate selected color and show error text
  $eachProduct.each(function(){
    var $this = $(this);
    var $thisInput = $this.find('.jsc-bundle-variant-hidden');
    var $thisVarColor =$thisInput.attr('data-color');
    var $thisError = $this.find('.extra-error');

    if ($thisVarColor == '' ) {
      $thisError.addClass('show-error');
    }
    else {
      $thisError.removeClass('show-error');
      countSelectedType += 1;
    }
  });
  console.log($mainDiscounted);
  //end: to calculate selected color

  var $products = [];
  $eachProduct.each(function(){
    var $this = $(this);
    var $thisInput = $this.find('.jsc-bundle-variant-hidden');
    var $thisVarID = parseInt($thisInput.attr('data-id'));
    var $thisVarAvail =$thisInput.attr('data-var-avail');
    var $thisTitle = $thisInput.attr('data-prodtitle');
    var $thisTitle_en = $thisInput.attr('data-prodTitle-en');
    // console.log('$thisTitle_en',$thisTitle_en);
    if ($thisTitle_en !== undefined) {
      var $this_en_title = $thisTitle_en.replace('en-', '');
      console.log('shirtbundle');
    }
    
   
    countLoop += 1;

    if ($thisVarAvail && countSelectedType ==  $loopLimit ) {
      var $objMainClone = Object.assign({}, $objMain);
      $objMainClone['_Sequence'] = $thisTitle;
      $objMainClone['_Sequence_en'] = $this_en_title;

      var $product = {};
      $product['id'] = $thisVarID;
      $product['quantity'] = 1;
      $product['properties'] = $objMainClone;

      $products.push($product);
    }
  });
  if ($products.length > 0) {
  CartJS.addItems($products,
  {
    "success": function(data, textStatus, jqXHR) {
        location.reload();
    },
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", textStatus);
    }
  });
  }
}

//start: bed builder template
onloadBedBuilder = () => {
  var builder = $('.jsc-colorSwatch.bedbuilder-template');
  var $requireSelectSize = $('.bedbuilder-template').attr('data-require-select-size');
  console.log($requireSelectSize);
  if (builder.length > 0) {
    
    var productSection = builder.find('.jsc-main-bedbuilder .jsc-section-bb');

    if ($requireSelectSize == 'false') {
      $('.jsc-collection-content-color').removeClass('d-none');
    } 

    productSection.each(function(){
      var $this = $(this);
      var $thisCollection = $this.find('.jsc-active-bb-collection');
      var $thisInputSize = $this.find('.jsc-section-details').attr('data-size');
      var $thisSizeExists = $this.attr('data-size-exist');

      $thisCollection.children().each(function(){
        var $_this = $(this);
        var $_thisSize = $_this.attr('data-size');

        // if ($_thisSize == $thisInputSize) {
        //   $_this.addClass('jsc-active-bb-size');
        // } else {
        //   $_this.addClass('jsc-inactive-bb-size');
        // }

        if ($thisSizeExists == 'true') {
          if ($_thisSize == $thisInputSize) {
            $_this.addClass('jsc-active-bb-size');
          } else {
            $_this.addClass('jsc-inactive-bb-size');
          }
        } else {
          $_this.addClass('jsc-active-bb-size');
        }

      });
    });

    var productSectionExtra = builder.find('.jsc-additional-bedbuilder .jsc-section-bb');

    productSectionExtra.each(function(){
      var $this = $(this);
      var $thisCollection = $this.find('.jsc-active-bb-collection');
      var $thisInputSize = $this.find('.jsc-section-details').attr('data-size');
      var $thisAddonSection = $this.attr('data-section');
      var $thisSizeExists = $this.attr('data-size-exist');
      // console.log($thisAddonSection,$thisSizeExists);
      
      $thisCollection.children().each(function(){
        var $_this = $(this);
        var $_thisSize = $_this.attr('data-size');

        // if ($_thisSize == $thisInputSize) {
        //   $_this.addClass('jsc-active-bb-size');
        // } else {
        //   $_this.addClass('jsc-inactive-bb-size');
        // }

        if ($thisSizeExists == 'true') {
          if ($_thisSize == $thisInputSize) {
            $_this.addClass('jsc-active-bb-size');
          } else {
            $_this.addClass('jsc-inactive-bb-size');
          }
        } else {
          $_this.addClass('jsc-active-bb-size');
        }

      });
    });
  }
}
jscBBcollection = (e,collection,sectionType) => {
  var $this = $(e);
  var $thisDropdown;
  var $thisSection;
  var $thisSectionInput;
  var $thisSectionInputDefault;
  var $thisSectionContent;
  var $thisSectionContentCollection;
  var $resetActiveColor;
  var $resetSize;
  var $mobileSection = $this.parents('body').find('.jsc-section-bb');
  var $firstSizeReset;
  var $thisSizeExists;
  var $requireSelectSize = $('.bedbuilder-template').attr('data-require-select-size');
  
  if ($(window).width() > 1025) {
    
    $thisDropdown = $this.parents('.jsc--dropdown-collection');
    $thisSection = $this.parents('.jsc-section-bb');
    $thisSectionInput = $thisSection.children('.jsc-section-details');
    $thisSectionInputDefault = $thisSection.children('.jsc-section-default-details');
    $thisSectionContent = $thisSection.children('.jsc-section-content');
    $thisSectionContentCollection = $thisSectionContent.find('.jsc-content-color .jsc-collection-content-color');
    $resetSize = $thisSectionInputDefault.attr('data-size');

    $this.parents('.jsc-container-collSize').find('.jsc--dropdown-size .jsc-size-dropdown-title').html($resetSize);
    $firstSizeReset = $this.parents('.jsc-container-collSize').find('.jsc--dropdown-size .popover .popover-listbox__option').first();
    $firstSizeReset.attr('aria-selected','true');
    $firstSizeReset.siblings().removeAttr('aria-selected');
    $thisSizeExists = $thisSection.attr('data-size-exist');

    //start: show dummy collection
    if ($requireSelectSize == 'true') {
      jscShowDummyCollection($thisSection,$thisSectionInput);
    }
    //end: show dummy collection
    
  } else {
    
    $mobileSection.each(function() {
      var $thisSection = $(this).attr('data-section-type');
      
      if (sectionType == $thisSection) {
        
        $thisDropdown = $(this).find('.jsc--dropdown-collection');
        $thisSectionInput = $(this).find('.jsc-section-details');
        $thisSectionInputDefault = $(this).find('.jsc-section-default-details');
        $thisSectionContent = $(this).find('.jsc-section-content');
        $thisSectionContentCollection = $(this).find('.jsc-content-color .jsc-collection-content-color');
        $resetSize = $thisSectionInputDefault.attr('data-size');

        $(this).find('.jsc--dropdown-size .jsc-size-dropdown-title').html($resetSize);
        $firstSizeReset = $(this).find('.jsc--dropdown-size .popover .popover-listbox__option').first();
        $firstSizeReset.attr('aria-selected','true');
        $firstSizeReset.siblings().removeAttr('aria-selected');
        $thisSizeExists = $(this).attr('data-size-exist');

        //start: show dummy collection
        if ($requireSelectSize == 'true') {
          jscShowDummyCollection($(this),$thisSectionInput);
        }
        //end: show dummy collection
      }
    });

    $this.attr('aria-selected','true');
    $this.siblings().removeAttr('aria-selected');
  }

  $thisDropdown.find('.jsc-collection-dropdown-title').html(collection);
  //start: to display selector result
  
  //end: to display selector result
  
  $thisSectionInput.attr('data-collection',collection);
  $thisSectionInput.attr('data-var-id','');
  $thisSectionInput.attr('data-price','');
  $thisSectionInput.attr('data-var-avail','');

  //start: to display the selected collection
  $thisSectionContentCollection.each(function(){
    var $_this = $(this);
    var $_thisCollection = $_this.attr('data-collection');
    
    
    if ($_thisCollection.includes(collection)) {
      // console.log($_thisCollection);
      $_this.addClass('jsc-active-bb-collection');
      $_this.removeClass('jsc-inactive-bb-collection');
      
    }
    else {
      $_this.addClass('jsc-inactive-bb-collection');
      $_this.removeClass('jsc-active-bb-collection');
    }
  });
  //end: to display the selected collection

  //start: reset the color swatch to display the first size(single) of the selected collection
  $resetActiveColor = $thisSectionContent.find('.jsc-active-bb-collection .jsc-bb-color-swatch');
  $resetActiveColor.each(function() {
    var $_this = $(this);
    var $_thisSize = $_this.attr('data-size');
    // console.log('here2',$thisSizeExists);
    // if ($_thisSize == $resetSize) {
    //   $_this.addClass('jsc-active-bb-size');
    //   $_this.removeClass('jsc-inactive-bb-size');
    // } else {
    //   $_this.addClass('jsc-inactive-bb-size');
    //   $_this.removeClass('jsc-active-bb-size');
    // }
    if ($thisSizeExists == 'true') {
      if ($_thisSize == $resetSize) {
        $_this.addClass('jsc-active-bb-size');
        $_this.removeClass('jsc-inactive-bb-size');
      } else {
        $_this.addClass('jsc-inactive-bb-size');
        $_this.removeClass('jsc-active-bb-size');
      }
    } else {
      $_this.addClass('jsc-active-bb-size');
      $_this.removeClass('jsc-inactive-bb-size');
    }
      
  });
  
  $thisSectionInput.attr('data-size',$resetSize);
  $thisSectionContentCollection.find('.jsc-active-bb-size .jsc-bundle-dummy-style').removeClass('bundle-active');
  $thisSectionContentCollection.find('.jsc-active-bb-size.jsc-chosen-color').removeClass('jsc-chosen-color');
  $thisSectionContent.find('.jsc-selected-color-title').html('');

  //end: reset the color swatch to display the first size(single) of the selected collection
  
  $thisSectionContent.find('.jsc-container-color-info').removeClass('d-none');


}
jscBBsize = (e,size,sectionType) => {
  var $this = $(e);
  var $thisSection;
  var $thisSectionInput;
  var $thisSectionContent;
  var $thisSectionContentCollection;
  var $mobileSection = $this.parents('body').find('.jsc-section-bb');
  var $thisDropdown;
  var $requireSelectSize = $('.bedbuilder-template').attr('data-require-select-size');
  
  if ($(window).width() > 1025) {
    $thisSection = $this.parents('.jsc-section-bb');
    $thisSectionInput = $thisSection.children('.jsc-section-details');
    $thisSectionContent = $thisSection.children('.jsc-section-content');
    $thisSectionContentCollection = $thisSectionContent.find('.jsc-content-color .jsc-collection-content-color.jsc-active-bb-collection');
    $thisDropdown = $this.parents('.jsc--dropdown-size');

    //start: to display selector result
    if ($requireSelectSize == 'true') {
      $thisDropdown.find('.jsc-static-type').removeClass('d-none');
      $thisDropdown.find('.jsc-size-dropdown-title').removeClass('d-none');
      $thisDropdown.find('.jsc-default-select-size').hide();
    }
    //end: to display selector result

    //start: hide dummy collection
    if ($requireSelectSize == 'true') {
      jscHideDummyCollection($thisSection,$thisSectionInput);
    }
    //end: hide dummy collection
    
  } else {
    
    $mobileSection.each(function() {
      var $thisSection = $(this).attr('data-section-type');
      
      if (sectionType == $thisSection) {
        $thisSectionInput = $(this).find('.jsc-section-details');
        $thisSectionInputDefault = $(this).find('.jsc-section-default-details');
        $thisSectionContent = $(this).find('.jsc-section-content');
        $thisSectionContentCollection = $(this).find('.jsc-content-color .jsc-collection-content-color.jsc-active-bb-collection');
        $resetSize = $thisSectionInputDefault.attr('data-size');

        $(this).find('.jsc--dropdown-size .jsc-size-dropdown-title').html(size);
        if ($requireSelectSize == 'true') {
          $(this).find('.jsc--dropdown-size .jsc-static-type').removeClass('d-none');
          $(this).find('.jsc--dropdown-size .jsc-size-dropdown-title').removeClass('d-none');
          $(this).find('.jsc--dropdown-size .jsc-default-select-size').hide();
        }

        //start: hide dummy collection
        if ($requireSelectSize == 'true') {
          jscHideDummyCollection($(this),$thisSectionInput);
        }
        //end: hide dummy collection
        
      }
    });

    $this.attr('aria-selected','true');
    $this.siblings().removeAttr('aria-selected');
    
  }
  
  $thisSectionInput.attr('data-size',size);
  $thisSectionInput.attr('data-var-id','');
  $thisSectionInput.attr('data-price','');
  $thisSectionContentCollection.find('.jsc-active-bb-size .jsc-bundle-dummy-style').removeClass('bundle-active');
  $thisSectionContentCollection.find('.jsc-active-bb-size.jsc-chosen-color').removeClass('jsc-chosen-color');
  $thisSectionContent.find('.jsc-selected-color-title').html('');

  $thisSectionContentCollection.children().each(function(){
    var $_this = $(this);
    var $_thisSize = $_this.attr('data-size');
    
    if ($_thisSize == size) {
      $_this.addClass('jsc-active-bb-size');
      $_this.removeClass('jsc-inactive-bb-size');
    }
    else {
      $_this.addClass('jsc-inactive-bb-size');
      $_this.removeClass('jsc-active-bb-size');
    }
    
  });

}

jscRecordBBSwatch = (e,color,varID,varAvail,prodSection,size,varImg,itemType,price,addon) => { 
  var $this = $(e);
  var $singletextDiv = $this.parents('.jsc-section-content').find('.jsc-container-selected-color');
  $singletextDiv.find('.jsc-selected-color-title').html(color);
  $this.parents('.jsc-section-bb').find('.jsc-section-title-div .jsc-selected-color-title').html(color); //display next to section title
  var $thisSection = $this.parents('.jsc-section-bb');
  var $thisSectionInput = $thisSection.children('.jsc-section-details');
  var $thisMainSet = $this.parents('.bedbuilder-template').find('.jsc-bedbuilder-set .jsc-bedbuilder-main .jsc-set-item');
  var $thisAdditionalSet = $this.parents('.bedbuilder-template').find('.jsc-bedbuilder-set .jsc-bedbuilder-additional .jsc-set-item-extra');
  var title = $thisSection.attr('data-section');
  var collection = $thisSectionInput.attr('data-collection');
  $this.siblings().removeClass('jsc-chosen-color');
  var $thisColor = $(e).parents('.jsc-active-bb-collection').find('.jsc-chosen-color'); 
  var $mainPrice = 0;
  var $addonPrice = 0;
  var discountAttr = $('.bedbuilder-template .jsc-builder-discount').attr('data-disc-value');
  
  // console.log($thisColor.length);
 
  $thisSectionInput.attr('data-var-id',varID);
  $thisSectionInput.attr('data-var-avail',varAvail);
  $thisSectionInput.attr('data-price',price);
  $this.addClass('jsc-chosen-color');
  $this.find('.jsc-bundle-dummy-style').addClass('bundle-active');
  $this.siblings().find('.jsc-bundle-dummy-style').removeClass('bundle-active');
  
  $thisSection.find('.jsc-section-title-div .jsc-checkmark-circle').removeClass('d-none');
  $thisSection.find('.jsc-section-title-div .jsc-dash').removeClass('d-none');
  $thisSection.find('.jsc-section-title-div .jsc-section-title').addClass('bold');
  $thisSection.find('.extra-error').removeClass('show-error');
  $thisSection.find('.jsc-section-content .jsc-remove-addon').removeClass('d-none');

  console.log(addon);
  //start: to append variant image
      // if (itemType == 'Add-on') {
      //   title = addon;
      // }
  title = addon;

  var $productImage = $('.jsc-product-gallery-media');
  $productImage.find('.jsc-overlay-var-img').each(function(){
    var $this_data = $(this).attr('data-type');
    if ($this_data == title) {
      $(this).remove();
    }
  });
  
  var sequence = 0;
  if (prodSection == 'fitted-sheet') {
    sequence = 1;
  } else if (prodSection == 'duvet-cover') {
    sequence = 4;
  }
  else if (addon == 'addon-pillow-case-pair' || addon == 'addon-pillow-case-pair1') {
    sequence = 2;
  }
  else if (prodSection == 'pillow-case-pair' || prodSection == 'pillow-case-pair1') {
    sequence = 3;
  }
  else if (addon == 'addon-bolster-case') {
    sequence = 5;
  }
  else {
    sequence = 2;
  }
  
  $productImage.append('<img class="jsc-overlay-var-img" src="'+varImg+'" data-type="'+title+'" style="z-index:'+ sequence +'" >');
  //end: to append variant image

  //start: to update set result
  if (itemType == 'Main') {
    $thisMainSet.each(function(){
      var $_this = $(this);
      var $_thisItem = $_this.attr('data-item');
      if ($_thisItem == addon) {
        $_this.find('span').removeClass('jsc-hide-content');
        $_this.find('.jsc-item-collection').html(collection);
        $_this.find('.jsc-item-color').html(color);
        $_this.find('.jsc-item-size').html(size);
      }
    });
  } else {
    //start: allow deselect addon items
    var addonPrice = $thisSection.find('.jsc-addon-price');
    var format_addonPrice = Shopify.formatMoney(price, $('body').data('money'));
    addonPrice.html('<span> +' + format_addonPrice + '</span>')

    if ($thisColor.length > 0) {
      console.log($thisColor.length,'deselect');
      $thisColor.removeClass('jsc-chosen-color');
      $thisColor.find('.jsc-bundle-dummy-style').removeClass('bundle-active');
      $thisSectionInput.attr('data-var-id','');
      $thisSectionInput.attr('data-var-avail','');
      $thisSectionInput.attr('data-price','');
      $thisSection.find('.jsc-section-title-div .jsc-checkmark-circle').addClass('d-none');
      $thisSection.find('.jsc-section-title-div .jsc-dash').addClass('d-none');
      $thisSection.find('.jsc-section-title-div .jsc-section-title').removeClass('bold');
      $singletextDiv.find('.jsc-selected-color-title').html('');
      $this.parents('.jsc-section-bb').find('.jsc-section-title-div .jsc-selected-color-title').html('');
      $thisSection.find('.jsc-section-content .jsc-remove-addon').addClass('d-none');
      addonPrice.html('');
      $productImage.find('.jsc-overlay-var-img').each(function(){
        var $this_data = $(this).attr('data-type');
        if ($this_data == title) {
          $(this).remove();
          console.log('deselect',$this_data);
        }
      });
    } else {
      console.log($thisColor.length,'select');
      // $thisColor.addClass('jsc-chosen-color');
    }
   
    $thisAdditionalSet.each(function(){
      var $_thisX = $(this);
      var $_thisItemX = $_thisX.attr('data-item-extra');
      if ($_thisItemX == addon) {
        $_thisX.find('span').removeClass('jsc-hide-content');

        if ($thisColor.length > 0) {
          $_thisX.find('.jsc-item-collection').html('');
          $_thisX.find('.jsc-item-color').html('');
          $_thisX.find('.jsc-item-size').html('');
          $_thisX.find('.jsc-item-in-text').addClass('jsc-hide-content');
          $_thisX.find('.jsc-item-size-text').addClass('jsc-hide-content');

        } else {
          $_thisX.find('.jsc-item-collection').html(collection);
          $_thisX.find('.jsc-item-color').html(color);
          if (size == '') {
            $_thisX.find('.jsc-item-in-text').addClass('jsc-hide-content');
            $_thisX.find('.jsc-item-size-text').addClass('jsc-hide-content');
          } else {
            $_thisX.find('.jsc-item-size').html(size);
          }
        }
        
      }
    });
    //end: allow deselect addon items
    
  }  
  //end: to update set result

  //start: get product price
  jscBuilderPrice($mainPrice,$addonPrice,discountAttr);
  //end: get product price

  //start: for loungewear set
  if (addon == 'loungewear-set') {
    jscLoungewearPrice();
  }
  //end: for loungewear set
}
jscBuilderPrice = ($mainPrice,$addonPrice,discountAttr) => {

  var $main_afterDiscount = 0; //sum of per-item discounted prices, before roundoff
  var $main_afterDiscountRounded = 0; //sum of per-item discounted prices, each rounded off

  $('.jsc-main-bedbuilder .jsc-section-details').each(function(){
    var $_this = $(this);
    var $price = $_this.attr('data-price');
    var $priceInt = parseInt($price);
    if ($price != '') {
      $mainPrice += $priceInt;
      var discounted_beforeRound = $priceInt * ((100 - parseInt(discountAttr))/100); //item price after discount & before roundoff
      var discounted_afterRound = Math.round(discounted_beforeRound/100) * 100; //item price after discount & after roundoff
      $main_afterDiscount += discounted_beforeRound;
      $main_afterDiscountRounded += discounted_afterRound;
    }
  });
  $('.jsc-additional-bedbuilder .jsc-section-details').each(function(){
    var $_this = $(this);
    var $price = $_this.attr('data-price');
    var $priceInt = parseInt($price);
    if ($price != '') {
      $addonPrice += $priceInt;
    }
  });
  var $beforeDiscount = $mainPrice + $addonPrice; //total price of main items & addon before discount & before roundoff
  var $total_afterDiscount = $main_afterDiscount + $addonPrice; //total price of main items & addon after discount & before roundoff
  var roundedTotal = $main_afterDiscountRounded + $addonPrice; //total price of main items (each rounded off) & addon after discount

  if ($pricing_format == 'default') {
    var $savedDiscount = $beforeDiscount - $total_afterDiscount; // with cents value
  } else {
    var $savedDiscount = $beforeDiscount - roundedTotal; //without cents value
    var $roundSavedDiscount = (Math.round($savedDiscount/100)) * 100;
  }
  var format_beforeDiscount = Shopify.formatMoney($beforeDiscount, $('body').data('money'));

  if ($pricing_format == 'default') {
    var format_mainDiscount = Shopify.formatMoney($main_afterDiscount, $('body').data('money'));
  } else {
    var format_mainDiscount = Shopify.formatMoney($main_afterDiscountRounded, $('body').data('money'));
  }

  console.log('$pricing_format',$pricing_format);
  if ($pricing_format == 'default') {
    var format_savedDiscount = Shopify.formatMoney($savedDiscount, $('body').data('money'));
    var format_afterDiscount = Shopify.formatMoney($total_afterDiscount, $('body').data('money'));
  } else {
    var format_savedDiscount = Shopify.formatMoney($roundSavedDiscount, $('body').data('money'));
    var format_afterDiscount = Shopify.formatMoney(roundedTotal, $('body').data('money'));

    if ($pricing_hide_cents == 'true') {
      format_savedDiscount = format_savedDiscount.replace('.00','');
      format_afterDiscount = format_afterDiscount.replace('.00','');
    }
    
  }

  // console.log('full total b4 discount',$beforeDiscount,'full total after discount',$total_afterDiscount,'rounded total after discount',roundedTotal,'saved value',$savedDiscount,'total after discount & rounded',$main_afterDiscountRounded);

  $('.jsc-bedbuilder-price .price-beforeDiscount').html('<span>' + format_beforeDiscount + '</span>');
  $('.jsc-bedbuilder-price .price-afterDiscount').html('<span>' + format_afterDiscount + '</span>');
  $('.jsc-bedbuilder-price .price-savedDiscount').html('<span>' + format_savedDiscount + '</span>');

  $('.jsc-bb-save-price').removeClass('d-none');

  $('.jsc-bb-price-details').attr('data-main-price-discounted',format_mainDiscount);
}
jscResetBBSet = (e,sectionType) => {
  var $this = $(e);
  var $thisSection;
  var $thisMainSet;
  var $thisAdditionalSet;
  var prodSection;
  var prodSectionType;
  var $productImage = $('.jsc-product-gallery-media');
  var $thisSectionTitle;
  var $mainPrice = 0;
  var $addonPrice = 0;
  var discountAttr = $('.bedbuilder-template .jsc-builder-discount').attr('data-disc-value');
  var $mobileSection = $this.parents('body').find('.jsc-section-bb');

  
  if ($(window).width() > 1025) {

    $thisSection = $this.parents('.jsc-section-bb');
    prodSection = $thisSection.attr('data-section');
    prodSectionType = $thisSection.attr('data-section-type');
    $thisSectionTitle = $thisSection.children('.jsc-section-title-div'); 

  } else {

    $mobileSection.each(function() {
      
      prodSectionTypeCheck = $(this).attr('data-section-type');
      if (sectionType == prodSectionTypeCheck) {
        $thisSection = $(this);
        prodSection = $thisSection.attr('data-section');
        prodSectionType = $thisSection.attr('data-section-type');
        $thisSectionTitle = $thisSection.children('.jsc-section-title-div');
        // console.log(sectionType,prodSection);
      }
    });
  }
  $thisMainSet = $thisSection.parents('.bedbuilder-template').find('.jsc-bedbuilder-set .jsc-bedbuilder-main');
  $thisAdditionalSet = $thisSection.parents('.bedbuilder-template').find('.jsc-bedbuilder-set .jsc-bedbuilder-additional');
  
  //start: to remove the details at section title
  $thisSection.find('.jsc-section-title-div .jsc-checkmark-circle').addClass('d-none');
  $thisSection.find('.jsc-section-title-div .jsc-section-title').removeClass('bold');
  $thisSectionTitle.find('.jsc-dash').addClass('d-none');
  $thisSectionTitle.find('.jsc-selected-color-title').html('');
  $thisSectionTitle.find('.jsc-addon-price').html('');
  $thisSection.find('.jsc-remove-addon').addClass('d-none'); //hide Remove button after clicked
  //end: to remove the details at section title
  
  //start: reset the content of Your Set
  $thisMainSet.children().each(function(){
    var $_this = $(this);
    var $_thisItem = $_this.attr('data-item');
    
    if ($_thisItem == prodSectionType) {
      console.log('REMOVE MAIN SET',$_thisItem,prodSectionType);
      $_this.find('.jsc-item-in-text').addClass('jsc-hide-content');
      $_this.find('.jsc-item-size-text').addClass('jsc-hide-content');
      $_this.find('.jsc-item-collection').html('');
      $_this.find('.jsc-item-color').html('');
      $_this.find('.jsc-item-size').html('');
    }
  });
  $thisAdditionalSet.children().each(function(){
    var $_thisX = $(this);
    var $_thisItemX = $_thisX.attr('data-item-extra');
    // console.log($_thisItemX,prodSection,prodSectionType);
    
    if ($_thisItemX == prodSectionType) {
      console.log('REMOVE ADDON SET',$_thisItemX,prodSectionType);
      $_thisX.find('.jsc-item-in-text').addClass('jsc-hide-content');
      $_thisX.find('.jsc-item-size-text').addClass('jsc-hide-content');
      $_thisX.find('.jsc-item-collection').html('');
      $_thisX.find('.jsc-item-color').html('');
      $_thisX.find('.jsc-item-size').html('');
    }
  });
  //end: reset the content of Your Set

  //start: remove image from gallery
  $productImage.find('.jsc-overlay-var-img').each(function(){
    var $this_data = $(this).attr('data-type');
    if ($this_data == prodSectionType) {
      $(this).remove();
    }
  });
  //end: remove image from gallery
  jscBuilderPrice($mainPrice,$addonPrice,discountAttr);
}
jscBedBuilderATC = (e,template,set,url,$totalItem,prodID,excludeBundle) => {
  var title = $(e).siblings('.jsc-get-prodtitle').attr('data-title');
  var en_title = $(e).siblings('.jsc-get-prodtitle').attr('data-en-title');
  var th_title = $(e).siblings('.jsc-get-prodtitle').attr('data-th-title');
  var $mainSet = $('.bedbuilder-template .jsc-main-bedbuilder');
  var $eachProduct = $mainSet.find('.jsc-section-bb');
  var $loopLimit = $mainSet.find('.jsc-item-limit').attr('data-limit');
  var countSelectedType = 0;
  var countLoop = 0;
  var $AdditionalSet = $('.bedbuilder-template .jsc-additional-bedbuilder');
  var $eachProductAddon = $AdditionalSet.find('.jsc-section-bb');
  var $mainDiscounted = $('.jsc-bb-price-details').attr('data-main-price-discounted');
  
  var discountAttr = $('.bedbuilder-template .jsc-builder-discount');
  var discountType = discountAttr.attr('data-disc-type');
  var discountvalue = discountAttr.attr('data-disc-value');
  var $obj = {};
  var $objMain = {};
  var $objAddon = {};
  var $bindID = set + ',' + $date_time;
  $obj[template] = 'Main Items';
  $obj['_Quantity-Promo'] = discountType;
  $obj['_Off-Value'] = discountvalue;
  $obj['_BindID'] = $bindID;
  $obj['_Total-Item'] = $totalItem;
  $obj['_DummyProductID'] = prodID;
  $objMain[template] = 'Main Items';
  $objMain['_Quantity-Promo'] = discountType;
  $objMain['_Off-Value'] = discountvalue;
  $objMain['_BindID'] = $bindID;
  $objMain['_MainProduct'] = true;
  $objMain['_DummyProduct'] = title;
  $objMain['_DummyProductUrl'] = url;
  $objMain['_MainPriceDiscounted'] = $mainDiscounted;
  $objAddon[template] = 'Additional Items';
  $objMain['_Total-Item'] = $totalItem;
  $objMain['_DummyProductID'] = prodID;
  $objMain['_ExcludeBundle'] = excludeBundle;

  if (en_title != '' && th_title != '') {
    var $en_title = en_title.replace('en-title_', '');
    var $th_title = th_title.replace('th-title_', '');
    $objMain['_En-Title'] = $en_title;
    $objMain['_Th-Title'] = $th_title;
  }

  // console.log(set,$date_time,$bindID);

  //start: scroll to main section when selection is incomplete
  var divElement = $('.product-info__description');
  var divPosition = divElement.offset().top;
  //end: scroll to main section when selection is incomplete
  
  //start: to calculate selected color and show error text
  $eachProduct.each(function(){
    var $this = $(this);
    var $thisInput = $this.find('.jsc-section-details');
    var $thisVarID = $thisInput.attr('data-var-id');
    var $thisError = $this.find('.extra-error');
    // console.log($thisVarID);
    if ($thisVarID == '' ) {
      $thisError.addClass('show-error');
      //start: scroll to main section when selection is incomplete
      window.scrollTo({top: divPosition, behavior: 'smooth'});
      //end: scroll to main section when selection is incomplete
    }
    else {
      $thisError.removeClass('show-error');
      countSelectedType += 1;
    }
  });
  // console.log(countSelectedType);
  //end: to calculate selected color

  var $products = [];
  $eachProductAddon.each(function(){
    var $this = $(this);
    var $thisInput = $this.find('.jsc-section-details');
    var $thisVarID = parseInt($thisInput.attr('data-var-id'));
    var $thisVarAvail =$thisInput.attr('data-var-avail');

    if ($thisVarAvail && countSelectedType ==  $loopLimit ) {
      var $product = {};
      $product['id'] = $thisVarID;
      $product['quantity'] = 1;
      $product['properties'] = $objAddon;
      $products.push($product);
    }
  });

  $eachProduct.each(function(){
    var $this = $(this);
    var $thisInput = $this.find('.jsc-section-details');
    var $thisVarID = parseInt($thisInput.attr('data-var-id'));
    var $thisVarAvail =$thisInput.attr('data-var-avail');
    countLoop += 1;

    
    if ($thisVarAvail && countSelectedType ==  $loopLimit ) {
      var $product = {};
      $product['id'] = $thisVarID;
      $product['quantity'] = 1;
      $product['properties'] = $objMain;
      $products.push($product);
    }
  });

  if ($products.length > 0) {
    CartJS.addItems($products,
    {
      "success": function(data, textStatus, jqXHR) {
          location.reload();
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", textStatus);
      }
    });
  }
}

//start: dummy collection swatches in bed builder
jscDummyCollection = (e) => {
  var $this = $(e);
  var $thisSection;
  var $sizeError;

  $thisSection = $this.parents('.jsc-section-bb');
  $sizeError = $thisSection.find('.extra-error-size');
  $sizeError.addClass('show-error');

  if ($(window).width() > 1025) {
    //$thisSection = $this.parents('.jsc-section-bb');
  } else {
    
  }
  //console.log($thisSection);
}
jscHideDummyCollection = (thisSection,thisSectionInput) => {
  //this function is used to hide the dummy collection section & size error text
  //triggered when customer select on size picker

  var $sizeError;
  $sizeError = thisSection.find('.extra-error-size');
  $sizeError.removeClass('show-error'); // hide Size error text

  var $thisCollectionShort = thisSectionInput.attr('data-collection');
  var $dummyCollSection = thisSection.find('.jsc-dummy-collection');

  $dummyCollSection.each(function(){
    var $thisCollName = $(this).attr('data-collection');

    if ($thisCollName.includes($thisCollectionShort)) {
      $(this).removeClass('jsc-active-dummy-collection');
      $(this).addClass('jsc-inactive-dummy-collection');
      // $(this).find('.jsc-bb-color-swatch').removeClass('jsc-inactive-bb-size');

      var $realActiveColl = $(this).siblings('.jsc-active-bb-collection');
      $realActiveColl.removeClass('d-none'); //display real collection's swatches

    } else {
      
    }
  })
}
jscShowDummyCollection = (thisSection,thisSectionInput) => {
  //this function is used to hide the dummy collection section & size error text
  //triggered when customer select on collection picker

  var $sizeError;
  $sizeError = thisSection.find('.extra-error-size');
  $sizeError.removeClass('show-error'); // hide Size error text
  var $dataSectionType = thisSection.attr('data-section-type');

  setTimeout(function(){

    var $thisCollectionShort = thisSectionInput.attr('data-collection');
    var $dummyCollSection = thisSection.find('.jsc-dummy-collection');
    // console.log($thisCollectionShort);
    $dummyCollSection.each(function(){
      var $thisCollName = $(this).attr('data-collection');
      
      if ($thisCollName.includes($thisCollectionShort)) {
        $(this).addClass('jsc-active-dummy-collection'); //show dummy collection of the selected collection
        $(this).removeClass('jsc-inactive-dummy-collection');
        $(this).find('.jsc-bb-color-swatch').removeClass('jsc-inactive-bb-size');

        var $realActiveColl = $(this).siblings('.jsc-active-bb-collection');
        $realActiveColl.addClass('d-none'); //hide real collection's swatches

      } else {
        $(this).removeClass('jsc-active-dummy-collection');
        $(this).addClass('jsc-inactive-dummy-collection');
      }
      // $(this).show();
    })
  },500);
  var $thisSizeDropdown = thisSection.find('.jsc--dropdown-size .jsc-select-size'); // to display Select Size text
  if ($dataSectionType == 'main-pillow-case-pair') {
    
  } else {
    $thisSizeDropdown.find('.jsc-static-type').addClass('d-none');
    $thisSizeDropdown.find('.jsc-size-dropdown-title').addClass('d-none');
    $thisSizeDropdown.find('.jsc-default-select-size').show();
  }
}
//end: dummy collection swatches in bed builder

jscReload = () => {
  setTimeout(function(){
    location.reload();
  },1000);
  
}
jscReloadQuick = () => {
    location.reload();
}
jscReloadLonger = () => {
  var toReload = 0;

  setTimeout(function(){
    var myInterval = setInterval( function(){

      var pageUrl = window.location.href;
      var prodTitle = $('.jsc-product-info__title').attr('data-title');

      if (pageUrl.includes(prodTitle)) {
        toReload = 1;
      } else {
        toReload = 0;
      }

      if (toReload == 1) {
        location.reload();
        clearInterval(myInterval);
      }
      console.log(prodTitle,pageUrl,toReload);
    } , 1000);
  },1500);
  
}
jscRemoveBuilderBundle = (e,bindId) => {
  // console.log(bindId);

  var itemsToRemove = [];

  $.when($.getJSON('/cart.js', function(cart) {
    var _cartItems = cart.items;
  
    $.each(_cartItems, function(index, item) { // Iterate over the cart items
      
      if (item.properties && item.properties['_BindID'] === bindId) { // Check if the item has the desired line item properties
        // Get the line number of the item
        var lineNumber = index + 1; // Adding 1 because line numbers are usually 1-based
  
        itemsToRemove.push(lineNumber); // store the line number in an array
        sessionStorage.setItem("cartIndex", JSON.stringify(itemsToRemove));
      }
    });
  })).then(function() {
   
    // setTimeout(function(){
      for (var i = itemsToRemove.length - 1; i >= 0; i--) {
          console.log(itemsToRemove[i],'reverse');
          // cartJSRemoveItem(itemsToRemove[i]);
          cartJSUpdateItem(itemsToRemove[i], 0, {}, true);
      }

    // },500);

  });
  
}
jscRemoveAddon = (e,title,prodSection) => {
  var $this = $(e);
  var $thisSection = $this.parents('.jsc-section-bb');
  var $thisSectionInput = $thisSection.children('.jsc-section-details');
  var $thisColor = $thisSection.find('.jsc-chosen-color');
  var $thisSectionTitle = $thisSection.children('.jsc-section-title-div'); 
  var addonPrice = $thisSection.find('.jsc-addon-price');
  var $productImage = $('.jsc-product-gallery-media');
  var $thisAdditionalSet = $this.parents('.bedbuilder-template').find('.jsc-bedbuilder-set .jsc-bedbuilder-additional .jsc-set-item-extra');
  var $mainPrice = 0;
  var $addonPrice = 0;
  var discountAttr = $('.bedbuilder-template .jsc-builder-discount').attr('data-disc-value');

  $thisSectionInput.attr('data-var-id','');
  $thisSectionInput.attr('data-var-avail','');
  $thisSectionInput.attr('data-price','');
  $thisSectionTitle.find('.jsc-section-title').removeClass('bold');
  $thisSectionTitle.find('.jsc-checkmark-circle').addClass('d-none');
  $thisSectionTitle.find('.jsc-dash').addClass('d-none');
  $thisSectionTitle.find('.jsc-selected-color-title').html('');
  $thisSectionTitle.find('.jsc-addon-price').html('');
  $thisColor.removeClass('jsc-chosen-color');
  $thisSection.find('.jsc-bundle-dummy-style').removeClass('bundle-active');
  addonPrice.html('');

  $productImage.find('.jsc-overlay-var-img').each(function(){
    var $this_data = $(this).attr('data-type');
    if ($this_data == title) {
      $(this).remove();
      console.log('remove',$this_data);
    }
  });

  $thisAdditionalSet.each(function(){
    var $_thisX = $(this);
    var $_thisItemX = $_thisX.attr('data-item-extra');

    if ($_thisItemX == title) {
      $_thisX.find('.jsc-item-collection').html('');
      $_thisX.find('.jsc-item-color').html('');
      $_thisX.find('.jsc-item-size').html('');
      $_thisX.find('.jsc-item-in-text').addClass('jsc-hide-content');
      $_thisX.find('.jsc-item-size-text').addClass('jsc-hide-content');      
    }
  });

  jscBuilderPrice($mainPrice,$addonPrice,discountAttr);

  $this.addClass('d-none'); //hide Remove button after clicked
}
//end: bed builder template
onloadjscBlog = () => {
  var $gridHandle = $('.jsc-blogpost-grid');
  var tabhandle = $('.jsc-blog-tabs .jsc-blog-tabs-each.jsc-active-blog').attr('data-blog');
  $gridHandle.each(function(){
    var $this = $(this);
    var $thisHandle = $this.attr('data-handle');
    // var $thisParentTab = $this.parents('.jsc-blog-template').find('.jsc-blog-tabs .jsc-blog-tabs-each');
    $this.hide();
    // $this.removeClass('jsc-active-bloggrid');
    // $thisParentTab.removeClass('jsc-active-blog'); 
    console.log();

    if ($thisHandle == tabhandle) {
      $this.show();
      $this.addClass('jsc-active-bloggrid');     
    }
    else {
      $this.addClass('jsc-inactive-bloggrid');
    }
  });

}
jscBlog = (e,handle) => {
  var $_this = $(e);
 
  var $gridHandle = $('.jsc-blogpost-grid');
  

  $gridHandle.each(function(){
    var $this = $(this);
    var $thisHandle = $this.attr('data-handle');
    var $thisParentTab = $this.parents('.jsc-blog-template').find('.jsc-blog-tabs .jsc-blog-tabs-each');
    $this.hide();
    $this.removeClass('jsc-active-bloggrid');
    $thisParentTab.removeClass('jsc-active-blog'); 
    console.log();

    if (($thisHandle == handle) || (handle == 'true')) {
      $this.show();
      $this.addClass('jsc-active-bloggrid');     
    }
    else {
      $this.addClass('jsc-inactive-bloggrid');
    }
  });
  $_this.addClass('jsc-active-blog');
  // console.log(handle);
}

showDescTab = (e) => {
  

  if ($(window).width() < 480) {
    var $thisTabParent = $(e).parent();
    $thisTabParent.addClass('jsc-active-footer-tab');
    $thisTabParent.removeClass('jsc-inactive-footer-tab');
    $thisTabParent.siblings('.jsc-footer-accordion').removeClass('jsc-active-footer-tab');
    $thisTabParent.siblings('.jsc-footer-accordion').addClass('jsc-inactive-footer-tab');

    var selectedTab = $(e).parent('.jsc-active-footer-tab').find('.jsc-footer-content');
    var checkTab = selectedTab.attr('data-check');
    var unselectedTab = $('.jsc-inactive-footer-tab');

    if (checkTab == 'checked') {
      // console.log('checked');
      selectedTab.attr('data-check','');
      selectedTab.hide();
      $(e).find('.jsc-footer-circle-chevron').removeClass('jsc-footer-circle-chevron-rotate');
      $(e).find('.jsc-footer-circle-chevron').addClass('jsc-footer-circle-chevron-rotate-normal');

      // $(e).find('.fa-minus').hide();
      // $(e).find('.fa-plus').show();
    }
    else {
      // console.log('unchecked');
      selectedTab.attr('data-check','checked');
      selectedTab.show();
      $(e).find('.jsc-footer-circle-chevron').addClass('jsc-footer-circle-chevron-rotate');
      $(e).find('.jsc-footer-circle-chevron').removeClass('jsc-footer-circle-chevron-rotate-normal');

      // $(e).find('.fa-minus').show();
      // $(e).find('.fa-plus').hide();
    }

    //to close other tabs (allow only 1 to open at a time)
    unselectedTab.find('.jsc-footer-content').hide();
    unselectedTab.find('.jsc-footer-content').attr('data-check','');
    unselectedTab.find('.jsc-footer-circle-chevron').removeClass('jsc-footer-circle-chevron-rotate');
    unselectedTab.find('.jsc-footer-circle-chevron').addClass('jsc-footer-circle-chevron-rotate-normal');

    // unselectedTab.find('.fa-minus').hide();
    // unselectedTab.find('.fa-plus').show();
  }
  
}

onloadSizeGuideTable = () => {
  var $sizeguideTable = $('.jsc-sizeguide-page');
  // console.log('test1');
  if ($sizeguideTable.length > 0) {

    var $cmMeasurement = $('.cm-measurement');
    // console.log('test2');
    $cmMeasurement.each(function(){
      var $thisCM = $(this);
      $thisCM.hide();
    });

  }

}
onclickSizeGuideTable = (e,measurement) => {

  var $inchMeasurement = $('.inch-measurement');
  var $cmMeasurement = $('.cm-measurement');
  // console.log(measurement);

  if (measurement == 'inch') {
    $cmMeasurement.each(function(){
      var $thisCM = $(this);
      $thisCM.hide();
    });
    $inchMeasurement.each(function(){
      var $thisInch = $(this);
      $thisInch.show();
    });
  } else {

    $cmMeasurement.each(function(){
      var $thisCM = $(this);
      $thisCM.show();
    });
    $inchMeasurement.each(function(){
      var $thisInch = $(this);
      $thisInch.hide();
    });
  }

  $(e).addClass('active-tab');
  $(e).siblings().removeClass('active-tab');
  
}
onloadDisplaySizeGuide = () => {
  var $sizeguideNav = $('.jsc-sizeguide-nav .jsc-active-sizeguide').attr('data-type');
  var $sizeguideTable = $('.jsc-sizeguide-page');

  $sizeguideTable.each(function(){
    var $this = $(this);
    var $thisTitle = $this.attr('data-title');

    $this.hide();
    if ($sizeguideNav == $thisTitle) {
      $this.show();
    }
  });
  // console.log($sizeguideNav);
  
}
onclickDisplaySizeGuide = (e,title) => {
  var $sizeguideTable = $('.jsc-sizeguide-page');
  var $inchMeasurement = $('.inch-measurement');
  var $cmMeasurement = $('.cm-measurement');
  var $measureTab = $(e).parent().siblings('.jsc-measurement-div').find('.individual-size-tab');

  $sizeguideTable.each(function(){
    var $this = $(this);
    var $thisTitle = $this.attr('data-title');

    $this.hide();
    if (title == $thisTitle) {
      $this.show();
      $this.find('.individual-size-tab.inch-size').addClass('active-tab');
      $this.find('.individual-size-tab.cm-size').removeClass('active-tab');
    }
  });
  $cmMeasurement.each(function(){
    var $thisCM = $(this);
    $thisCM.hide();
  });
  $inchMeasurement.each(function(){
    var $thisInch = $(this);
    $thisInch.show();
  });
  // console.log($measureTab);
  $(e).addClass('jsc-active-sizeguide');
  $(e).siblings().removeClass('jsc-active-sizeguide');
  $measureTab.first().addClass('active-tab');
  $measureTab.last().removeClass('active-tab');
}

jscPDPsizeguide = (e,title) => {
  var pageContent = $('.jsc-pdp-sg-tabs-content').find('.jsc-pdp-sg-tabs-content-each');
  $(e).addClass('active-sg-tab');
  $(e).siblings().removeClass('active-sg-tab');
  var $thisTitle;

  if ($(window).width() < 480) {
    $thisTitle = $(e).val();
  } else {
    $thisTitle = title;
  }

  pageContent.each(function(){
    var $this = $(this);
    var $thisContent = $this.attr('data-content');
    $this.hide();
    if ($thisContent == $thisTitle) {
      $this.show();
    }
  });
}

initFlickityBlogTabs = () => {
  if ($(window).width() < 480) {
    
    var timer = setInterval(function() {

    if ($('.jsc-slider-blog-tabs').length > 0 ) {

            var flkty = new Flickity( '.jsc-slider-blog-tabs' , {
            // options
            cellAlign: 'center',
            contain: true,
            pageDots: false,
            groupCells: false,
            wrapAround: false,
            draggable: true,
            prevNextButtons: false,
            autoPlay: false,
            on: {
                ready: function() {
                $(this.element).addClass('jsc-flickity-initiated');
                }
            }
            });
        

        }


        clearInterval(timer);
    })
  }
}

jscDisablePageScroll = (e,check) => {

  if (check == 'true') {
    $(e).parents('body').addClass('modal-open');
  } else {
    $(e).parents('body').removeClass('modal-open');
  }
  
}

jscPackagingNote = (e,title) => {
  var $this = $(e);
  $this.find('input').attr('checked','checked').prop('checked', true);
  $this.siblings('.jsc-each-radio').find('input').prop('checked', false);
  $this.siblings('.jsc-each-radio').find('input').removeAttr('checked');
  
  var type = $this.find('input').val();
  console.log(type);
  $('.jsc-each-radio-input').each(function() {
    var $this = $(this);
    var dataInput = $this.attr('data-input');

    if (dataInput == title) {
      $this.addClass('jsc-active-note-input');
      $this.removeClass('jsc-inactive-note-input');
    } else {
      $this.removeClass('jsc-active-note-input');
      $this.addClass('jsc-inactive-note-input');
    }
  });
}
jscClearCartAttr = () => {
  var $enable_popup = $('#cartModal').attr('data-enable-popup');
  var storedArray = JSON.parse(sessionStorage.getItem('cartIndex'));
  var run_gwp = true;

              
  if ($enable_popup == 'true') {
  
    $.when($.getJSON('/cart.js',{ cache: false }, function(cart) {
      _cartItems = cart.items;
      
    })).then(function(){
      var itemsIndex = 0;
      for (var i = 0; i < _cartItems.length; i++) {
        // console.log('loop cart');
        var _itemsBindID = _cartItems[i].properties['_BindID'];
        itemsIndex += 1;

        $('.jsc-cartpage-bedbuilder-line_item').each(function(){
          var $this = $(this);
          var $totalItem = $this.attr('data-total-item');
          var $thisSetBindID = $this.attr('data-bindid');
          var $eachItem = $this.find('.jsc-individual-bundle-item');
          var $countTotalItem_cartpage = 0;
      
          $eachItem.each(function(){
            $countTotalItem_cartpage += 1;
          });
          
      
          if ($totalItem != '') {
            if ($countTotalItem_cartpage != $totalItem) { console.log('incomplete');
              run_gwp = false;

              if (_itemsBindID == $thisSetBindID) {
                console.log("This bundle in your cart is incomplete!",$thisSetBindID,'index',itemsIndex,storedArray);
                
                if (storedArray != null) { console.log('run session storage');
                  for (var i = 0; i < storedArray.length; i++) {
                    
                    if (storedArray[i] == itemsIndex) {
                      // Perform operations on the element
                      var _itemsKey = _cartItems[i].key;
                      console.log('Element:', storedArray[i], _itemsKey);
                      //cartJSRemoveItem(storedArray[i]);
                      cartJSUpdateItem(storedArray[i], 0, {}, true);
                      
                      secondFunction();
                       
                    } 
  
                  }

                } else { console.log('run popup');
                  setTimeout(function(){ 
                
                    $('#cartModal').css('display','flex');
                    $('body').addClass('modal-open');
                    sessionStorage.clear();
                  },2000);
                }
                

              }
            }
          } 
          
        });
        
      } 
      
      console.log(run_gwp);
      if (run_gwp == true) {
        console.log('run gwp');
        masterPromo(false);
      }
    });
    
    
    function secondFunction() {
      $(document).on('cart.requestComplete', function(event, cart) {
        setTimeout(function(){ 
          sessionStorage.clear();
          
          console.log('clear storage after remove item');
          location.reload();
        },1000);
      });
    }
  }

  
}
onclickCartRemoveIncomplete = (e) => {

  $('#cartModal').css('display','none');
  $('body').removeClass('modal-open');

  $.when($.getJSON('/cart.js', function(cart) {
    _cartItems = cart.items;
    
  })).then(function(){
    for (var i = 0; i < _cartItems.length; i++) {
      var _itemsKey = _cartItems[i].key;
      var _itemsBindID = _cartItems[i].properties['_BindID'];

      $('.jsc-cartpage-bedbuilder-line_item').each(function(){
        var $this = $(this);
        var $totalItem = $this.attr('data-total-item');
        var $thisSetBindID = $this.attr('data-bindid');
        var $eachItem = $this.find('.jsc-individual-bundle-item');
        var $countTotalItem_cartpage = 0;
    
        $eachItem.each(function(){
          $countTotalItem_cartpage += 1;
        });
    
        if ($totalItem != '') {
          if ($countTotalItem_cartpage != $totalItem) {          
            
            if (_itemsBindID == $thisSetBindID) {
              console.log('to remove',_itemsBindID);
              cartJSUpdateQuery(_itemsKey, 0, {}, true);
            }
          }
        }
      });
      
    }
  }); 
}

jscCustomATC = (e,checkPreorder) => {
  var varId = $(e).parents('.shopify-product-form').find('.jsc-input-id').val();
  var var_info = $(e).siblings('.jsc-product-info').find('.jsc-variant-info-each');
  var varQty = $(e).parents('.product-info').find('.product-info__quantity-selector .quantity-selector__input').val();
  var isGiftbox = $(e).parents('.shopify-product-form').find('.jsc-input-id').data('is-giftbox');
  var $obj = {};

  if (checkPreorder == 'true') {
    $obj['_preorder_item'] = 'true';
  }
  // console.log(varId,varQty);
  var_info.each(function(){
    var $thisID = $(this).attr('data-id');

    if ($thisID == varId) {
      var $thisAvail = $(this).attr('data-available');
      if ($thisAvail == 'true') {
        $('.jsc-email-error').hide();
        if ($('.giftCardCheck').prop('checked') == true) {
            if (!$('.email.field__input').val()) {
                $('.jsc-email-error').show();
            }else{

              
              $obj['Recipient email'] = $('.email.field__input').val();
              $obj['Recipient name'] = $('.name.field__input').val();
              $obj['Message'] = $('.text-area.field__input').val();
              $obj['Send on'] = $('.date.field__input').val();
              $obj['__shopify_send_gift_card_to_recipient'] = $('.recipiendtcontrol').val();

              cartJSAddQuery(varId,varQty,$obj,true);
            }
        }
        else if(isGiftbox == true){
          jscAddGiftBox(varId);
        }
        else{
        // console.log(varId,$thisAvail,varQty);
        cartJSAddQuery(varId,varQty,$obj,true);
        }
      }
    }
  });
  

}
jscUpdateBtnATC = (e,color,checkPreorder) => {
  var storeRoute = $('.jsc-store-routes').attr('data-route');
  var storeLang = $('.jsc-store-routes').attr('data-theme-settings-lang');
  var text_atc = 'Add to cart';
  var text_soldout = 'Sold Out';
  
  if (storeLang == 'english') {
    if (storeRoute.includes('/th')) {
      text_atc = 'เพิ่มลงในตะกร้า';
      text_soldout = 'หมด';
    } else {
      
    }
  } else {
    if (storeRoute.includes('/en')) {
      
    } else {
      text_atc = 'เพิ่มลงในตะกร้า';
      text_soldout = 'หมด';
    }
  }
  // console.log(storeRoute,storeLang,text_atc,text_soldout);

  setTimeout(function(){
    var productContainer = $(e).parents('.product-info');
    var btn_varID = productContainer.find('.product-info__buy-buttons .jsc-input-id').val();
    var allVariant = productContainer.find('.product-info__buy-buttons .jsc-product-info');
    var custom_btn = productContainer.find('.product-info__buy-buttons .jsc-custom-buy-buttons');
    var $selected_color = productContainer.find('.product-info__variant-picker .jsc-selected-var.jsc-color-var');
    $selected_color.text(color);
    // console.log(color);
    
    allVariant.children().each(function(){
      var $this = $(this);
      var $thisId = $this.attr('data-id');
      var $thisTitle = $this.attr('data-title');
      var $thisAvail = $this.attr('data-available');
  
      if ($thisId == btn_varID) {
        productContainer.find('.product-info__buy-buttons .jsc-input-id').attr('data-available',$thisAvail);
        if ($thisAvail == 'true') {
          custom_btn.removeClass('button--subdued');
          custom_btn.removeAttr('disabled');

          if (checkPreorder == 'true') {
            custom_btn.html('Pre-order');
          } else {
            custom_btn.html(text_atc);
          }
        } else {
          custom_btn.addClass('button--subdued');
          custom_btn.html(text_soldout);
          custom_btn.attr('disabled','disabled');
        }        
      }
    });

    
  },100);

  setTimeout(function(){
    var var_available = $(e).parents('.product-info').find('.product-info__buy-buttons .jsc-input-id').attr('data-available');
    // start :hide/show BIS button
    if (var_available == 'true') {
      $(e).parents('.product-info').find('.product-info__buy-buttons .jsc-bis-button-href').css('display','none');
    } else {
      $(e).parents('.product-info').find('.product-info__buy-buttons .jsc-bis-button-href').css('display','block');
    }
    // end :hide/show BIS button
  },500);
}

jscScrollTop = () => {
  // console.log('scroll');
  window.scrollTo({top: 0, behavior: 'smooth'});
}
jscClickSelector = (e) => {
  var $otherDropdown;
  var $thisDropdown;
  var $bedBuilder = $('.bedbuilder-template .popover');
  var $mobileSection = $(e).parents('body').find('.jsc-hide-popup');
  
  if ($(window).width() > 1025) {
    
    $bedBuilder.each(function(){
      var $this = $(this);
      $this.addClass('jsc-hide-popup');
      // $this.removeClass('jsc-show-popup');
    });
    
    $(e).siblings().removeClass('jsc-hide-popup');
    // $(e).siblings().addClass('jsc-show-popup');

    $otherDropdown = $(e).parent().siblings().find('.popover');
    $otherDropdown.removeAttr('open');
    //$thisDropdown = $(e).siblings('.popover').attr('inert');
    console.log('click dropdown desktop');
    
  } else {
    console.log('click dropdown mobile');
    $mobileSection.removeClass('jsc-hide-popup');
    $mobileSection.siblings('.popover').addClass('jsc-hide-popup');
  }

}
jscCloseSelector = (e) => {
  if ($(window).width() > 1025) {
    // console.log('close dropdown desktop');
    $(e).parents('.popover').removeClass('jsc-show-popup').addClass('jsc-hide-popup');
  } else {
    // console.log('close dropdown mobile');
  }
  
}

onloadBundlePrice = () => {
  var $bundle = $('.bundle-template .jsc-bundle-form');
  var $total_beforeDiscount = 0;
  var $total_afterDiscount = 0;
  var $total_afterDiscountOriginal = 0;
  
  $bundle.each(function(){
    var $this = $(this);
    var $varpriceRaw = $this.find('.jsc-bundle-discount').attr('data-price');
    var $offValue = $this.find('.jsc-bundle-discount').attr('data-discount');
    $total_beforeDiscount += parseInt($varpriceRaw);
    
    var discounted_beforeRound = (($varpriceRaw / 100) * (100 - $offValue)) ;
    var discounted_afterRound = Math.round(discounted_beforeRound/100) * 100;
    //var savedPrice = $varpriceRaw - discounted_afterRound;
    // var format_savedPrice = Shopify.formatMoney(savedPrice, $('body').data('money'));
    $total_afterDiscountOriginal += discounted_beforeRound;
    $total_afterDiscount += discounted_afterRound;
    // console.log(discounted_beforeRound,discounted_afterRound,$offValue,'% discount');
  });

  if ($pricing_format == 'default') {
    var format_discounted = Shopify.formatMoney($total_afterDiscountOriginal, $('body').data('money'));
  } else {
    var format_discounted = Shopify.formatMoney($total_afterDiscount, $('body').data('money'));
    
    if ($pricing_hide_cents == 'true') {
      format_discounted = format_discounted.replace('.00','');
    }
  }
  
  //console.log('$pricing_format',$pricing_format,'onload bundle price',format_discounted);
  // console.log($total_beforeDiscount,format_discounted,$total_afterDiscountOriginal);
  $('.jsc-bundle-price-container .bundle-price-after-discount').html(format_discounted);
  $('.bundle-template .jsc-bb-price-details').attr('data-main-price-discounted',format_discounted);

}
onclickBundlePrice = (e) => {
  var $bundle = $('.bundle-template .jsc-bundle-form');
  var $total_beforeDiscount = 0;
  var $total_afterDiscount = 0;
  var $total_afterDiscountOriginal = 0;
  
  $bundle.each(function(){
    var $this = $(this);
    var $varpriceRaw = $this.find('.jsc-bundle-discount');
    var $offValue = $this.find('.jsc-bundle-discount').attr('data-discount');
    var $newpriceRaw = $this.find('.jsc-swatch-details .active-colors').attr('data-price');
    $varpriceRaw.attr('data-price',$newpriceRaw);
    var $updatedPrice = $varpriceRaw.attr('data-price');

    $total_beforeDiscount += parseInt($updatedPrice);
    
    var discounted_beforeRound = (($updatedPrice / 100) * (100 - $offValue)) ;
    var discounted_afterRound = Math.round(discounted_beforeRound/100) * 100;

    $total_afterDiscountOriginal += discounted_beforeRound;
    $total_afterDiscount += discounted_afterRound;
    
  });

  if ($pricing_format == 'default') {
    var format_discounted = Shopify.formatMoney($total_afterDiscountOriginal, $('body').data('money'));
  } else {
    var format_discounted = Shopify.formatMoney($total_afterDiscount, $('body').data('money'));

    if ($pricing_hide_cents == 'true') {
      format_discounted = format_discounted.replace('.00','');
    }
    
  }
  
  console.log('$pricing_format',$pricing_format,'onclick bundle price',format_discounted);
  //console.log($total_beforeDiscount,$total_afterDiscount,$total_afterDiscountOriginal);
  $('.jsc-bundle-price-container .bundle-price-after-discount').html(format_discounted);
  $('.bundle-template .jsc-bb-price-details').attr('data-main-price-discounted',format_discounted);
}
onloadRewardsPage = () => {
  var $rewardsDiv = $('.yotpo-widget-loyalty-page').parents('.section');
  var $accountRewardsDiv = $('.yotpo-widget-my-rewards-widget').parents('.section');
  $rewardsDiv.css('padding','0');
  $accountRewardsDiv.css('padding','0');
  $rewardsDiv.parents('.shopify-section--custom-html').siblings('.shopify-section--main-page').hide();
  // console.log('reward page',$rewardsDiv.length);
}
onloadCartClear = () => {
  cartJSUpdateQuery(44803695968556, 0, {}, true);
}

onclickInventoryApp = (e) => {
  
  if (window.location.href.includes('sojao-staging') || window.location.href.includes('shopifypreview')) {
    console.log('staging store');
  } else {
    $(e).parents('.product-info').find('.jsc-inventory-info-app .iia-container').remove();
    setTimeout(function(){
      
      var inventoryApp = $('.jsc-pdp-sizeguide-inventory').find('.jsc-inventory-info-app .iia-details-container');
      
      var myInterval = setInterval( function(){
        
        if (inventoryApp.length < 1 ) {
          // console.log(inventoryApp.length,'second2');
          $('#inventory-info-app').load('#inventory-info-app');
        }
        clearInterval(myInterval);
      } , 2000);
      
    },1000);
  }

}

jscHideExtraDropdown = (e) => {

  if ($( window ).width() < 1024) {
    // console.log('jsc close dropdown',e);
    //start: use when clicked from content
    $(e).parents('.popover.hide-tablet-down').removeAttr('open');
    $(e).parents('.popover.hide-tablet-down').siblings('.popover.hide-tablet-down').removeAttr('open');
    $(e).parents('.popover.hide-tablet-down').attr('inert');
    $(e).parents('.popover.hide-tablet-down').siblings('.popover.hide-tablet-down').attr('inert');
    //end: use when clicked from content

    //start: use when clicked from Close button
    $(e).removeAttr('open');
    $(e).siblings('.popover.hide-tablet-down').removeAttr('open');
    $(e).attr('inert');
    $(e).siblings('.popover.hide-tablet-down').attr('inert');
    //start: use when clicked from Close button
  }
  
}

jscHotspot = (e) => {

  var $thisSpot;
  var $otherSpot;

  if ($(window).width() > 1025) {
    $thisSpot = $(e).find('.hot-spot__dot');
    $otherSpot = $(e).siblings('.hot-spot').find('.hot-spot__dot');
    $otherSpot.attr('aria-expanded','false');
    $otherSpot.siblings('.hot-spot-popover').css({"display": "none", "opacity": "0", "visibility": "hidden"});
  } else {
    setTimeout(function(){
      $thisSpot = $(e).parents('body').find('main').siblings('.hot-spot-popover');
      if ($thisSpot.length > 1) {
        $thisSpot.last().css('display','none');
        $thisSpot.last().remove();
      }
      
    },200);
  }
  
}

//start: bundle set feature
onloadjscBundleSet = () => {
  setTimeout(function(){},2000);
    var $bedbundle = $('.jsc-bedbundle-colorSwatch');
    var $sizeinfo = $bedbundle.siblings('.product-info__variant-picker').find('.popover .popover-listbox__option');
    var $total_beforeDiscount = 0;
    var $total_afterDiscount = 0;
    var $total_afterDiscountOriginal = 0;
    var $checkStock = 0;
    var $checkVarMetafield = 'false';

    $sizeinfo.each(function() {
      var varSize = $(this).attr('data-var-size');

      if (varSize) {
        if ($bedbundle.length > 0) {
          $('.jsc-bedbundle-info .jsc-bedbundle-each-size').each(function() {
            var $this = $(this);
            var $thisIndex = $this.attr('id');
            var discountvalue = $this.attr('data-discount');
      
            if ($thisIndex == varSize) {
              var $varpriceRaw = $this.attr('data-price');

              $total_beforeDiscount += parseInt($varpriceRaw);

              var discounted_beforeRound = (($varpriceRaw / 100) * (100 - discountvalue)) ;
              var discounted_afterRound = Math.round(discounted_beforeRound/100) * 100;

              $total_afterDiscountOriginal += discounted_beforeRound;              
              $total_afterDiscount += discounted_afterRound;
              
              console.log(discounted_beforeRound,discounted_afterRound);
              $this.addClass('bedbundle-atc');

              //start:to display soldout button when the set is incomplete or out of stock
              var $thisStock = $this.attr('data-inventory');
              if ($thisStock < 1) {
                $checkStock += 1;
              }
              $checkVarMetafield = 'true';
              //end:to display soldout button when the set is incomplete or out of stock
            }
          });
          if ($checkVarMetafield == 'true') {
            console.log($checkStock,'of them is soldout A');
          }
          
          if ($checkStock > 0) {
            $('.jsc-buy-buttons').addClass('button--subdued').attr('disabled','disabled').html('SOLD OUT');
          }
          console.log('onloadjscBundleSet',$total_afterDiscount,$total_afterDiscountOriginal,'$pricing_format',$pricing_format);

          if ($pricing_format == 'default') {
            var format_discounted = Shopify.formatMoney($total_afterDiscountOriginal, $('body').data('money'));
          } else {
            var format_discounted = Shopify.formatMoney($total_afterDiscount, $('body').data('money'));

            if ($pricing_hide_cents == 'true') {
              format_discounted = format_discounted.replace('.00','');
            }
            
          }

          $('.jsc-bedbundle-colorSwatch .jsc-bb-price-details').attr('data-main-price-discounted',format_discounted);
          $('.product-info__price sale-price').html(format_discounted);
          
        }
        
      }
      
    });
  
}
jscBundleSet = (e,sizeIndex) => {
  var $bedbundle = $('.jsc-bedbundle-colorSwatch');
  var $total_beforeDiscount = 0;
  var $total_afterDiscount = 0;
  var $total_afterDiscountOriginal = 0;
  var $checkStock = 0;
  var $checkVarMetafield = 'false';

  if ($bedbundle.length > 0) {
    $('.jsc-bedbundle-info .jsc-bedbundle-each-size').each(function() {
      var $this = $(this);
      var $thisIndex = $this.attr('id');
      var discountvalue = $this.attr('data-discount');
      $this.removeClass('bedbundle-atc');
      if ($thisIndex == sizeIndex) {
        var $varpriceRaw = $this.attr('data-price');

        $total_beforeDiscount += parseInt($varpriceRaw);

        var discounted_beforeRound = (($varpriceRaw / 100) * (100 - discountvalue)) ;
        var discounted_afterRound = Math.round(discounted_beforeRound/100) * 100;

        $total_afterDiscountOriginal += discounted_beforeRound;
        $total_afterDiscount += discounted_afterRound;

        $this.addClass('bedbundle-atc');
        //start:to display soldout button when the set is incomplete or out of stock
        var $thisStock = $this.attr('data-inventory');
        if ($thisStock < 1) {
          $checkStock += 1;
        }
        $checkVarMetafield = 'true';
        //end:to display soldout button when the set is incomplete or out of stock
      }
    });
    if ($checkVarMetafield == 'true') {
      console.log($checkStock,'of them is soldout B');
    }
    
    if ($checkStock > 0) {
      $('.jsc-buy-buttons').addClass('button--subdued').attr('disabled','disabled').html('SOLD OUT');
      console.log('disable ATC button');
    } else {
      $('.jsc-buy-buttons').removeClass('button--subdued').removeAttr('disabled').html('ADD TO CART');
      console.log('enable ATC button');
    }

    console.log('jscBundleSet',$total_afterDiscount,$total_afterDiscountOriginal);

    if ($pricing_format == 'default') {
      var format_discounted = Shopify.formatMoney($total_afterDiscountOriginal, $('body').data('money'));
    } else {
      var format_discounted = Shopify.formatMoney($total_afterDiscount, $('body').data('money'));

      if ($pricing_hide_cents == 'true') {
        format_discounted = format_discounted.replace('.00','');
      }
      
    }
    
    setTimeout(() => {
      $('.jsc-bedbundle-colorSwatch .jsc-bb-price-details').attr('data-main-price-discounted',format_discounted);
      $('.product-info__price sale-price').html('');
      $('.product-info__price sale-price').html(format_discounted);
    }, 10);
    
    // console.log(format_discounted,'2');
  }
}
jscBedBundleATC = (e,set,url,$totalItem,prodID,excludeBundle) => {
  var title = $(e).siblings('.jsc-get-prodtitle').attr('data-title');
  var en_title = $(e).siblings('.jsc-get-prodtitle').attr('data-en-title');
  var th_title = $(e).siblings('.jsc-get-prodtitle').attr('data-th-title');
  var $objMain = {};
  var $bindID = set + ',' + $date_time;
  var countLoop = 0;
  var $checkStock = 0;
  var $allStockAvailable = 'true';
  $objMain['_BundlePrice'] = $('.jsc-bedbundle-colorSwatch .jsc-bb-price-details').attr('data-main-price-discounted');
  $objMain['_Quantity-Promo'] = 'percentage-off-bundle';
  $objMain['_BindID'] = $bindID;
  $objMain['_MainProduct'] = true;
  $objMain['_DummyProduct'] = title;
  $objMain['_DummyProductUrl'] = url;
  $objMain['_Total-Item'] = $totalItem;
  $objMain['_DummyProductID'] = prodID;
  $objMain['_ExcludeBundle'] = excludeBundle;
  if (en_title != '' && th_title != '') {
    var $en_title = en_title.replace('en-title_', '');
    var $th_title = th_title.replace('th-title_', '');
    $objMain['_En-Title'] = $en_title;
    $objMain['_Th-Title'] = $th_title;
  }

  $('.jsc-bedbundle-info .jsc-bedbundle-each-size.bedbundle-atc').each(function(){
    var $this = $(this);
    var $thisStock = $this.attr('data-inventory');
    
    if ($thisStock < 1) {
      $checkStock += 1; // to ensure all items are available
      $allStockAvailable = 'false';
    }
  });

  // console.log('all stock available',$allStockAvailable);

  var $products = [];
  $('.jsc-bedbundle-info .jsc-bedbundle-each-size.bedbundle-atc').each(function() {
    var $this = $(this);
    var $var_id = parseInt($this.attr('data-var-id'));
    var $var_prodtitle = $this.attr('data-var-prodtitle');
    var $var_title = $this.attr('data-var-title');
    var $var_avail = $this.attr('data-var-avail');
    var discountvalue = $this.attr('data-discount');
    // var $totalItem = $this.attr('data-total-item');
    
    countLoop += 1;
    // console.log('each stock available',$var_avail);
   
    if ($var_avail == 'true' && $allStockAvailable ==  'true') {
      var $objMainClone = Object.assign({}, $objMain); 
      $objMainClone['_Off-Value'] = discountvalue;

      var $product = {};
      $product['id'] = $var_id;
      $product['quantity'] = 1;
      $product['properties'] = $objMainClone;
      $products.push($product);
    }
  });
  if ($products.length > 0) {
  CartJS.addItems($products,
  {
    "success": function(data, textStatus, jqXHR) {
        location.reload();
    },
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", textStatus);
    }
  });
  }
}
//end: bundle set feature

jscCustomHotspot = (e) => {

  if ($(e).find('.jsc-hotspot-content.jsc-hotspot-active').length > 0) {
    // console.log('close hotspot');
    $(e).removeClass('jsc-hotspot-active-plus').addClass('jsc-hotspot-after-click');
    $(e).find('.jsc-hotspot-content.jsc-hotspot-active').removeClass('jsc-hotspot-active');
  }
  else {
    $(e).addClass('jsc-hotspot-active-plus').removeClass('jsc-hotspot-after-click');
    $(e).siblings('.jsc-desktop-hotspot').removeClass('jsc-hotspot-active-plus').addClass('jsc-hotspot-after-click');
    $(e).find('.jsc-hotspot-content').addClass('jsc-hotspot-active');
    $(e).siblings('.jsc-desktop-hotspot').find('.jsc-hotspot-content').removeClass('jsc-hotspot-active');
  }
  
}
onloadBISbutton = () => {
  // var stock = $('.jsc-select-version1').attr('data-stock');
  var var_id = $('.jsc-input-id').val();
  var stock = $('.jsc-input-id').attr('data-available');

  if (stock != 'true') {
    // $('.jsc-bis-button-href').show();
    $('.jsc-bis-button-href').css('display','block');
    $('.jsc-bis-button-href').removeClass('d-none');
    $('.jsc-bis-button-href').attr('data-variant-id',var_id);
  } else {
    // $('.jsc-bis-button-href').hide();
    $('.jsc-bis-button-href').css('display','none');
  }
}
jscBISbutton = (e,diff_button) => {
  setTimeout(function() {
    
    if ($(window).width() > 799) {
      var $product_info = $(e).parents('.popover').siblings('.jsc-variant-details');
      var $variant_info = $product_info.find('.jsc-each-variant');
      var $atc_var_id = $(e).parents('.product-info').find('.product-info__buy-buttons .jsc-input-id').val();
      var $this_bis_button = $(e).parents('.product-info').find('.product-info__buy-buttons .jsc-bis-button-href');
      var $this_atc_button = $(e).parents('.product-info').find('.product-info__buy-buttons .jsc-buy-buttons');
      var $this_jsc_custom_buy_buttons = $(e).parents('.product-info').find('.product-info__buy-buttons .jsc-custom-buy-buttons');
    } else {
      var parent_info = $(e).parents('.popover').siblings('.anchor.m-scene');
      var $product_info = parent_info.find('.shopify-section--main-product .product-info .jsc-variant-details');
      var $variant_info = $product_info.find('.jsc-each-variant');
      var $atc_var_id = parent_info.find('.shopify-section--main-product .product-info .product-info__buy-buttons .jsc-input-id').val();
      var $this_bis_button = parent_info.find('.shopify-section--main-product .product-info .product-info__buy-buttons .jsc-bis-button-href');
      var $this_atc_button = parent_info.find('.shopify-section--main-product .product-info .product-info__buy-buttons .jsc-buy-buttons');
      var $this_jsc_custom_buy_buttons = parent_info.find('.shopify-section--main-product .product-info .product-info__buy-buttons .jsc-custom-buy-buttons');
    }
    
    $variant_info.each(function(){
      var $thisID = $(this).attr('data-id');

      if ($thisID == $atc_var_id) {
        var $thisStock = $(this).attr('data-inventory');
        var $thisAvailable = $(this).attr('data-available');
        console.log($thisID,$atc_var_id,$thisStock,$thisAvailable); 
        if ($thisAvailable == 'false' ) {
          $this_bis_button.attr('data-variant-id',$atc_var_id);
          // $this_bis_button.show();
          $this_bis_button.css('display','block');
          $this_bis_button.removeClass('d-none');

          if (diff_button) {
            
          } else {
            $this_jsc_custom_buy_buttons.addClass('button--subdued').attr('disabled','disabled').html('SOLD OUT');
            $this_atc_button.addClass('button--subdued').attr('disabled','disabled').html('SOLD OUT');
          }

        } else {
          // $('.jsc-bis-button-href').hide();
          $this_bis_button.css('display','none');

          if (diff_button) {
            
          } else {
            $this_jsc_custom_buy_buttons.removeClass('button--subdued').removeAttr('disabled').html('ADD TO CART');
            $this_atc_button.removeClass('button--subdued').removeAttr('disabled').html('ADD TO CART');
          }
          
        }
      }
    });
    
  },500);
  
}

onloadRedirectPages = () => {
  var pageUrl = window.location.href;
  var newUrl;
  var storeRoute = $('.jsc-store-routes').attr('data-route');
  var storeURL = $('.jsc-store-routes').attr('data-shop-url');
  var thisPageURL = $('.jsc-store-routes').attr('data-page-url');
  var toRedirectFrom = storeURL + thisPageURL;
  var newRoute;

  if (storeRoute == '/en') {
    newRoute = storeRoute;
  } else {
    newRoute = '';
  }

  // console.log('current page',pageUrl, 'route',toRedirectFrom);
  if (toRedirectFrom.includes('/pages/organic-cotton-mens-shirt') ||
  toRedirectFrom.includes('/pages/organic-cotton-mens-shorts') ||
  toRedirectFrom.includes('/pages/organic-cotton-mens-lounge-pants') ||
  toRedirectFrom.includes('/pages/organic-cotton-mens-tee')) {
    newUrl = storeURL +  newRoute + '/collections/mens-loungewear';
    window.location.href = newUrl;
  }
  if (toRedirectFrom.includes('/pages/organic-cotton-womens-lounge-pants') || 
  toRedirectFrom.includes('/pages/organic-cotton-womens-shorts') ||
  toRedirectFrom.includes('/pages/organic-cotton-womens-tee') ||
  toRedirectFrom.includes('/pages/organic-cotton-womens-shirt')) {
    newUrl = storeURL +  newRoute + '/collections/womens-loungewear';
    window.location.href = newUrl;
  }
  if (pageUrl.includes('/pages/fitted-sheet-size')) {
    newUrl = storeURL +  newRoute + '/collections/fitted-sheets';
    window.location.href = newUrl;
  }
  if (pageUrl.includes('/pages/duvet-cover-size')) {
    newUrl = storeURL +  newRoute + '/collections/duvet-covers';
    window.location.href = newUrl;
  }
  if (pageUrl.includes('/pages/pillow-case') ||
  pageUrl.includes('/pages/large-pillow-case') ||
  pageUrl.includes('/pages/standard-pillow-case') ||
  pageUrl.includes('/pages/euro-sham-case')) {
    newUrl = storeURL +  newRoute + '/collections/pillow-cases';
    window.location.href = newUrl;
  }
  if (pageUrl.includes('/pages/quilts')) {
    newUrl = storeURL +  newRoute + '/products/organic-cotton-quilts';
    window.location.href = newUrl;
  }
  // if (pageUrl.includes('/pages/fringe-ombre-throw')) {
  //   newUrl =  storeURL +  newRoute + '/products/fringe-ombre-throw';
  //   window.location.href = newUrl;
  // }

  var exact_t1 = storeURL +  newRoute + '/collections/classic-additional';
  var exact_t2 = storeURL +  newRoute + '/collections/crisp-additional';
  var exact_t3 = storeURL +  newRoute + '/collections/classic';
  var exact_t4 = storeURL +  newRoute + '/collections/crisp';
  
  if (pageUrl == exact_t1 ||
  pageUrl == exact_t2 ||
  pageUrl == exact_t3 ||
  pageUrl == exact_t4) {
    newUrl = storeURL +  newRoute + '/pages/bedding';
    window.location.href = newUrl;
  }
  // if (pageUrl.includes('/pages/floor-mats')) {
  //   newUrl = storeURL +  newRoute + '/products/cotton-floor-mats';
  //   window.location.href = newUrl;
  // }
  // if (pageUrl.includes('/pages/cable-knit-throw')) {
  //   newUrl = 'https://sojao.shop/products/cable-knit-throw';
  //   window.location.href = newUrl;
  // }
  // if (pageUrl.includes('/pages/cushion-covers')) {
  //   newUrl = 'https://sojao.shop/collections/home-decor';
  //   window.location.href = newUrl;
  // }
  if (pageUrl.includes('/pages/face-towels')) {
    newUrl = storeURL +  newRoute + '/products/organic-face-towel-pair';
    window.location.href = newUrl;
  }
  if (pageUrl.includes('/pages/hand-towels')) {
    newUrl = storeURL +  newRoute + '/products/organic-hand-towels';
    window.location.href = newUrl;
  }
  if (pageUrl.includes('/pages/bath-towels')) {
    newUrl = storeURL +  newRoute + '/collections/bath-towels';
    window.location.href = newUrl;
  }
  if (pageUrl.includes('/pages/flat-sheet')) {
    newUrl = storeURL +  newRoute + '/collections/flat-sheet';
    window.location.href = newUrl;
  }
  if (pageUrl.includes('/pages/oxford-pillow-cases')) {
    newUrl = storeURL +  newRoute + '/products/classic-oxford-pillow-cases';
    window.location.href = newUrl;
  }
  if (pageUrl.includes('/pages/bolster-case')) {
    newUrl = storeURL +  newRoute + '/collections/bolster-body-cases';
    window.location.href = newUrl;
  }
  if (pageUrl.includes('/pages/body-pillow-case')) {
    newUrl = storeURL +  newRoute + '/collections/body-pillow-cases';
    window.location.href = newUrl;
  }
  if (pageUrl.includes('/pages/baby-cots')) {
    newUrl = storeURL +  newRoute + '/collections/baby-cot-sheets';
    window.location.href = newUrl;
  }
  if (pageUrl.includes('/pages/bolster-case')) {
    newUrl = storeURL +  newRoute + '/products/organic-bolster-case';
    window.location.href = newUrl;
  }
  if (pageUrl.includes('/pages/sojao-tote-bag')) {
    newUrl = storeURL +  newRoute + '/products/sojao-tote-bag';
    window.location.href = newUrl;
  }
  if (pageUrl.includes('/pages/organic-fantastic-tote-bag')) {
    newUrl = storeURL +  newRoute + '/products/organic-fantastic-tote-bag';
    window.location.href = newUrl;
  }
  if (pageUrl.includes('/pages/pet-quilts')) {
    newUrl = storeURL +  newRoute + '/products/organic-cotton-pet-quilts';
    window.location.href = newUrl;
  }
  
}

//start: yotpo onclick Redeem button
onloadYotpoRedeem = () => {
  // setTimeout(function(){
  //   var redeem_btn = $('.yotpo-action-button-widget .yotpo-button-standard-size').attr('aria-label');
  //   if (redeem_btn == 'REDEEM NOW') {
  //     $(".yotpo-action-button-widget .yotpo-button-standard-size").click(function () {
  //         $('html, body').scrollTop($('.yotpo-coupons-redemption-widget').offset().top);
  //     });
  //   }
  // },5000);
  var myInterval = setInterval( function(){
    var redeem_btn = $('.yotpo-action-button-widget .yotpo-button-standard-size').attr('aria-label');
        // console.log('find yotpo button',redeem_btn.length);
    if (redeem_btn.length > 0 ) { //console.log('found yotpo button')
      if (redeem_btn == 'REDEEM NOW') {
        $(".yotpo-action-button-widget .yotpo-button-standard-size").click(function () {
            $('html, body').scrollTop($('.yotpo-coupons-redemption-widget').offset().top);
        });
      }
      // clearInterval(myInterval);
    }
    
  } ,1000);
}
//end: yotpo onclick Redeem button
//start: gwp
cartGift = () =>{
  addCartGift();
  removeCartGift();
}

addCartGift = () =>{
  var $elem = $('.jsc-cart-gift');
  var $vid = $elem.val();
  var $obj = {};
  var $promoNo = $elem.attr('data-promo');
  var $gwp_quantity = $elem.attr('data-gwp-quantity');
  var removeGift = sessionStorage.getItem("FreeGift");
  $gwp_quantity = parseInt($gwp_quantity);
  var $elem_bundle = $('.jsc-cart-gift.jsc-cart-bundle-gift');

  // console.log($elem_bundle.length,'add gwp');
  if ($elem_bundle.length > 0) {
    $obj['_Cart_Gift_bundle'] = $promoNo;
  } else {
    $obj['_Cart_Gift'] = $promoNo;
  }
  
  $obj['_Cart_GWP'] = 'Free Gift';
  if ($elem.length > 0 ) {
    if (removeGift != 'Remove') {
      cartJSAddQuery($vid,$gwp_quantity,$obj,true);
    }

  }

}

removeCartGift = () =>{
  
  var $elem = $('.jsc-cart-gift-remove');
  var $key = $elem.val();

  if ($elem.length > 0) {
    console.log('auto remove gwp');
    cartJSUpdateQuery($key, 0, {}, true);
  }

  var $elem_bundle = $('.jsc-cart-gift-bundle-remove');
  var $key_bundle = $elem_bundle.val();
  var $elem_total = $elem_bundle.attr('data-gwp-total');

  if ($elem_bundle.length > 0) {
    console.log('auto reduce bundle gwp',$elem_total);
    cartJSUpdateQuery($key_bundle, $elem_total, {}, true);
  }
}

removeFreeGift = (e,varID) =>{
    sessionStorage.setItem("FreeGift", "Remove");
    // var varID = $('#jsc-cart-gift').val();
    var varID = varID;
    //console.log(varID);
    cartJSUpdateQuery(varID, 0);
    $(document).on('cart.requestComplete', function(event, cart) {
      location.reload();
   });
  }
//end: gwp

onclickLanguageSelector = () => {
  if ($(window).width() < 1025) {
    $('.shopify-localization-form').parents('.popover').css('z-index','9999999999');
  }
}


//start: sleepyhead set
jscSleepyheadSetATC = (e,template,set,url,$totalItem,prodID,excludeBundle) => {
  console.log('sleepyhead set atc')
  var title = $(e).siblings('.jsc-get-prodtitle').attr('data-title');
  var $mainSet = $('.bedbuilder-template .jsc-main-bedbuilder');
  var $eachProduct = $mainSet.find('.jsc-section-bb');
  var $loopLimit = $mainSet.find('.jsc-item-limit').attr('data-limit');
  var countSelectedType = 0;
  var countLoop = 0;
  var $mainDiscounted = $('.jsc-bb-price-details').attr('data-main-price-discounted');
  
  var $objMain = {};

  var $bindID = set + ',' + $date_time;
  $objMain[template] = 'Main Items';
  $objMain['_BindID'] = $bindID;
  $objMain['_MainProduct'] = true;
  $objMain['_DummyProduct'] = title;
  $objMain['_DummyProductUrl'] = url;
  $objMain['_MainPriceDiscounted'] = $mainDiscounted;

  $objMain['_Total-Item'] = $totalItem;
  $objMain['_DummyProductID'] = prodID;
  $objMain['_ExcludeBundle'] = excludeBundle;

  // console.log(set,$date_time,$bindID);

  //start: scroll to main section when selection is incomplete
  var divElement = $('.product-info__description');
  var divPosition = divElement.offset().top;
  //end: scroll to main section when selection is incomplete
  
  //start: to calculate selected color and show error text
  $eachProduct.each(function(){
    var $this = $(this);
    var $thisInput = $this.find('.jsc-section-details');
    var $thisVarID = $thisInput.attr('data-var-id');
    var $thisError = $this.find('.extra-error');
    // console.log($thisVarID);
    if ($thisVarID == '' ) {
      $thisError.addClass('show-error');
      //start: scroll to main section when selection is incomplete
      window.scrollTo({top: divPosition, behavior: 'smooth'});
      //end: scroll to main section when selection is incomplete
    }
    else {
      $thisError.removeClass('show-error');
      countSelectedType += 1;
    }
  });
  // console.log(countSelectedType);
  //end: to calculate selected color

  var $products = [];
  $eachProduct.each(function(){
    var $this = $(this);
    var $thisInput = $this.find('.jsc-section-details');
    var $thisVarID = parseInt($thisInput.attr('data-var-id'));
    var $thisVarAvail =$thisInput.attr('data-var-avail');
    $objMain['_Product Sequence'] = $thisInput.attr('data-seq');
    countLoop += 1;

    
    // console.log('loop 2',$thisVarID,$thisVarAvail,countSelectedType,$loopLimit);
    if ($thisVarAvail && countSelectedType ==  $loopLimit ) {
      var $objMainClone = Object.assign({}, $objMain);
      if (countLoop == 3) {
        $objMainClone['_Quantity-Promo'] = 'percentage-off';
        $objMainClone['_Off-Value'] = 100;
      }

      var $product = {};
      $product['id'] = $thisVarID;
      $product['quantity'] = 1;
      $product['properties'] = $objMainClone;

      $products.push($product);
    }
  });
  if ($products.length > 0) {
  CartJS.addItems($products,
  {
    "success": function(data, textStatus, jqXHR) {
        location.reload();
    },
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", textStatus);
    }
  });
  }
}
//end: sleepyhead set

// gift box start
jscAddGiftBox = (vid) => {
  var timeId = new Date().getTime();
  CartJS.addItem(vid, 1, {"_time_id":timeId});
}

jscUpdateGiftBox = (key, message) => {
  var timeId = new Date().getTime();
  if(message == ""){
    CartJS.updateItemById(key, 1, {"_time_id":timeId});
  }
  else {
    CartJS.updateItemById(key, 1, {"_time_id":timeId, "Gift Message":message});
  }
}

jscUpsellATC = (addBtn) =>{
  var vid = $(addBtn).parent().find('input[name="id"]').val();
  jscAddGiftBox(vid);
}

toggleMessageBox = (e) => {
  var giftMessageWrapper = $(e).parents('.jsc-gift-message-wrapper');
  var messageInput = giftMessageWrapper.find('.jsc-gift-message-input-wrapper');
  var key = $(e).data('line-item-key');
  if(e.checked){
    messageInput.css('display', 'inline-block');
  }
  else {
    messageInput.css('display', 'none');
    jscUpdateGiftBox(key, "");
  }
}

updateGiftMessage = (e) => {
  var giftMessageText = $(e).siblings('.jsc-gift-message-input').val();
  var key = $(e).data('line-item-key');
  jscUpdateGiftBox(key, giftMessageText);
}

onLoadToggleMessageBox = () => {
  var giftMessageText = $('.jsc-gift-message-wrapper .jsc-gift-message-input-wrapper .jsc-gift-message-input-box .jsc-gift-message-input');
  giftMessageText.each(function() {
    var textArea = $(this);
    if(textArea.val() != ""){
      var giftMessageWrapper = textArea.parents('.jsc-gift-message-wrapper');
      var checkBox = giftMessageWrapper.find('.jsc-gift-message-check');
      checkBox.prop('checked', true);
      checkBox.change();
    }
  })
}

updateCharacterCount = (e) => {
  var characterCount = $(e).val().length;
  var countText = $(e).parents('.jsc-gift-message-input-wrapper').find('.jsc-character-count');
  countText.text(characterCount);
}

onLoadUpdateCharacterCount = () => {
  var giftMessageText = $('.jsc-gift-message-wrapper .jsc-gift-message-input-wrapper .jsc-gift-message-input-box .jsc-gift-message-input');
  giftMessageText.each(function() {
    var textArea = $(this);
    var characterCount = textArea.val().length; 
    if(characterCount > 0){
      var countText = textArea.parents('.jsc-gift-message-input-wrapper').find('.jsc-character-count');
      countText.text(characterCount);
    }
  })
}

jscUpsellAddGiftBox = (e) => {
  var vid = $(e).data('vid');
  jscAddGiftBox(vid);
}
// gift box end

// giftcard recipient - Start
giftCardrecipient = (evt) => {
  $('.jsc-email-error').hide();
  if ($(evt).prop('checked') == true) {
      $('.recipient-fields').show();
      $('.email.field__input').attr('name','properties[Recipient email]');
      $('.name.field__input').attr('name','properties[Recipient name]');
      $('.text-area.field__input').attr('name','properties[Message]');
      $('.date.field__input').attr('name','properties[Send on]');
      $('.recipiendtcontrol').attr('name','properties[__shopify_send_gift_card_to_recipient]');
  }else{
      $('.recipient-fields').hide();
      $('.email.field__input').removeAttr('name');
      $('.name.field__input').removeAttr('name');
      $('.text-area.field__input').removeAttr('name');
      $('.date.field__input').removeAttr('name');
      $('.recipiendtcontrol').removeAttr('name');
  }
}
// giftcard recipient - End

//start: loungewear bundle
onloadLoungewearSet = () => {
  var loungewear_template = $('.jsc-colorSwatch.loungewear-template');

  if (loungewear_template.length > 0) {
    var productSection = loungewear_template.find('.jsc-main-bedbuilder .jsc-section-bb');
    // $('.jsc-collection-content-color').removeClass('d-none');

    productSection.each(function(){
      var $this = $(this);
      var $thisCollection = $this.find('.jsc-active-bb-collection');
      var $thisInputSize = $this.find('.jsc-section-default-details').attr('data-size');
      var $thisSizeExists = $this.attr('data-size-exist');
      // console.log($thisInputSize);
      $thisCollection.children().each(function(){
        var $_this = $(this);
        var $_thisSize = $_this.attr('data-size');

        if ($_thisSize == $thisInputSize) {
          $_this.addClass('jsc-active-bb-size');
        } else {
          $_this.addClass('jsc-inactive-bb-size');
        }

        // if ($thisSizeExists == 'true') {
        //   if ($_thisSize == $thisInputSize) {
        //     $_this.addClass('jsc-active-bb-size');
        //   } else {
        //     $_this.addClass('jsc-inactive-bb-size');
        //   }
        // } else {
        //   $_this.addClass('jsc-active-bb-size');
        // }

      });
    });
  }
}
jscResetCollection_LW = (e,prodHandle,collHandle) => {
  var type_section;
  var size_section;
  var color_section;
  var productSection;
  var productSectionInput;
  var $mobileSection = $(e).parents('body').find('.jsc-section-bb');
    
  if ($(window).width() > 1025) {
    productSection = $(e).parents('.jsc-section-bb');
    productSectionInput = productSection.find('.jsc-section-details');
    type_section = $(e).parents('.jsc--dropdown-loungewear-type');
    size_section = type_section.siblings('.jsc--dropdown-size');
    color_section = $(e).parents('.jsc-container-collSize').siblings('.jsc-container-color-info').find('.jsc-collection-content-color');

  } else {

    $mobileSection.each(function() {
      
      var prodSectionTypeCheck = $(this).attr('data-coll-handle');
      if (collHandle == prodSectionTypeCheck) {
        
        productSection = $(this);
        productSectionInput = productSection.find('.jsc-section-details');
        type_section = productSection.find('.jsc--dropdown-loungewear-type');
        size_section = type_section.siblings('.jsc--dropdown-size');
        color_section = productSection.find('.jsc-container-color-info .jsc-collection-content-color');

      }
    });
  }

  //start: input hidden
  productSectionInput.attr('data-collection',prodHandle);
  productSectionInput.attr('data-var-id','');
  productSectionInput.attr('data-var-avail','');
  productSectionInput.attr('data-price','');
  //end: input hidden

  size_section.each(function(){
    $(this).addClass('d-none');
    var $this_handle = $(this).attr('data-prod-handle');
    // console.log(prodHandle,$this_handle);
    if ($this_handle == prodHandle) {
      $(this).removeClass('d-none');
      var $current_size = $(this).find('.jsc-select-size').attr('data-size');
      productSection.find('.jsc-section-details').attr('data-size',$current_size);
      //console.log(prodHandle,$current_size);
    }
    
  });

  var productSectionSize = productSection.find('.jsc-section-details').attr('data-size');

  color_section.each(function(){
    $(this).addClass('d-none');
    $(this).addClass('jsc-inactive-bb-collection');
    $(this).removeClass('jsc-active-bb-collection');
    var $this_handle = $(this).attr('data-prod-handle');
    
    if ($this_handle == prodHandle) {
      $(this).removeClass('d-none');
      $(this).removeClass('jsc-inactive-bb-collection');
      $(this).addClass('jsc-active-bb-collection');
      var $active_color = $(this).find('.jsc-bb-color-swatch');
      // console.log($active_color);

      //start:show color swatch based on TYPE & SIZE
      $active_color.each(function(){
       
        var $each_size = $(this).attr('data-size');
        // console.log($each_size,productSectionSize);
        if ($each_size == productSectionSize) {
          $(this).addClass('jsc-active-bb-size');
          $(this).removeClass('jsc-inactive-bb-size');
          $(this).removeClass('jsc-chosen-color');
          $(this).find('.jsc-bundle-dummy-style').removeClass('bundle-active');
        }
        else {
          $(this).removeClass('jsc-active-bb-size');
          $(this).addClass('jsc-inactive-bb-size');
        }
      });
      //end:show color swatch based on TYPE & SIZE
      
    }
    
  });


  $thisSection = productSection;
  $thisSectionTitle = $thisSection.children('.jsc-section-title-div'); 

  //start: to remove the details at section title
  $thisSection.find('.jsc-section-title-div .jsc-checkmark-circle').addClass('d-none');
  $thisSection.find('.jsc-section-title-div .jsc-section-title').removeClass('bold');
  $thisSectionTitle.find('.jsc-dash').addClass('d-none');
  $thisSectionTitle.find('.jsc-selected-color-title').html('');
  $thisSectionTitle.find('.jsc-addon-price').html('');
  $thisSection.find('.jsc-remove-addon').addClass('d-none'); //hide Remove button after clicked
  //end: to remove the details at section title
  
  jscLoungewearPrice(); //to reset price
}
jscResetSize_LW = (e,size,collHandle) => {
  var productSection;
  var productSectionInput;
  var $this_dropdown;
  var $thisSectionContent;
  var $thisSectionContentCollection;
  var $mobileSection = $(e).parents('body').find('.jsc-section-bb');

  if ($(window).width() > 1025) {
    productSection = $(e).parents('.jsc-section-bb');
    productSectionInput = productSection.find('.jsc-section-details');
    $thisSectionContent = productSection.children('.jsc-section-content');
    $thisSectionContentCollection = $thisSectionContent.find('.jsc-content-color .jsc-collection-content-color.jsc-active-bb-collection');
    $this_dropdown = $(e).parents('.jsc--dropdown-size').find('.jsc-select-size');
    
  } else {
    $mobileSection.each(function() {
      
      var prodSectionTypeCheck = $(this).attr('data-coll-handle');
      if (collHandle == prodSectionTypeCheck) {
        console.log($(this));
        productSection = $(this);
        productSectionInput = productSection.find('.jsc-section-details');
        $thisSectionInputDefault = $(this).find('.jsc-section-default-details');
        $thisSectionContent = $(this).find('.jsc-section-content');
        $thisSectionContentCollection = $(this).find('.jsc-content-color .jsc-collection-content-color.jsc-active-bb-collection');
        $resetSize = $thisSectionInputDefault.attr('data-size');
        $this_dropdown = productSection.find('.jsc--dropdown-size').find('.jsc-select-size');

      }
    });
  }

  //start: input hidden
  productSectionInput.attr('data-var-id','');
  productSectionInput.attr('data-var-avail','');
  productSectionInput.attr('data-price','');
  productSectionInput.attr('data-size',size);
  //end: input hidden

  $thisSectionContentCollection.find('.jsc-active-bb-size .jsc-bundle-dummy-style').removeClass('bundle-active');
  $thisSectionContentCollection.find('.jsc-active-bb-size.jsc-chosen-color').removeClass('jsc-chosen-color');
  $thisSectionContent.find('.jsc-selected-color-title').html('');

  $thisSectionContentCollection.children().each(function(){
    var $_this = $(this);
    var $_thisSize = $_this.attr('data-size');
    
    if ($_thisSize == size) {
      $_this.addClass('jsc-active-bb-size');
      $_this.removeClass('jsc-inactive-bb-size');
    }
    else {
      $_this.addClass('jsc-inactive-bb-size');
      $_this.removeClass('jsc-active-bb-size');
    }
    
  });

  $this_dropdown.attr('data-size',size);

  $thisSection = productSection;
  $thisSectionTitle = $thisSection.children('.jsc-section-title-div'); 

  //start: to remove the details at section title
  $thisSection.find('.jsc-section-title-div .jsc-checkmark-circle').addClass('d-none');
  $thisSection.find('.jsc-section-title-div .jsc-section-title').removeClass('bold');
  $thisSectionTitle.find('.jsc-dash').addClass('d-none');
  $thisSectionTitle.find('.jsc-selected-color-title').html('');
  $thisSectionTitle.find('.jsc-addon-price').html('');
  $thisSection.find('.jsc-remove-addon').addClass('d-none'); //hide Remove button after clicked
  //end: to remove the details at section title
  jscLoungewearPrice()
  // console.log(size);
}
jscLoungewearATC = (e,template,set,url,$totalItem,prodID,excludeBundle) => {
  var title = $(e).siblings('.jsc-get-prodtitle').attr('data-title');
  var $mainSet = $('.bedbuilder-template .jsc-main-bedbuilder');
  var $eachProduct = $mainSet.find('.jsc-section-bb');
  var $loopLimit = $mainSet.find('.jsc-item-limit').attr('data-limit');
  var countSelectedType = 0;
  var countLoop = 0;
  var $mainDiscounted = $('.jsc-bb-price-details').attr('data-main-price-discounted');
  
  var discountAttr = $('.bedbuilder-template .jsc-builder-discount');
  var discountType = discountAttr.attr('data-disc-type');
  var discountvalue = discountAttr.attr('data-disc-value');
  var $obj = {};
  var $objMain = {};
  var $bindID = set + ',' + $date_time;
  $obj[template] = 'Main Items';
  $obj['_Quantity-Promo'] = discountType;
  $obj['_Off-Value'] = discountvalue;
  $obj['_BindID'] = $bindID;
  $obj['_Total-Item'] = $totalItem;
  $obj['_DummyProductID'] = prodID;
  $objMain[template] = 'Main Items';
  $objMain['_Quantity-Promo'] = discountType;
  $objMain['_Off-Value'] = discountvalue;
  $objMain['_BindID'] = $bindID;
  $objMain['_MainProduct'] = true;
  $objMain['_DummyProduct'] = title;
  $objMain['_DummyProductUrl'] = url;
  $objMain['_MainPriceDiscounted'] = $mainDiscounted;
  $objMain['_Total-Item'] = $totalItem;
  $objMain['_DummyProductID'] = prodID;
  $objMain['_ExcludeBundle'] = excludeBundle;

  // console.log(title,$eachProduct);

  //start: scroll to main section when selection is incomplete
  var divElement = $('.product-info__description');
  var divPosition = divElement.offset().top;
  //end: scroll to main section when selection is incomplete
  
  //start: to calculate selected color and show error text
  $eachProduct.each(function(){
    var $this = $(this);
    var $thisInput = $this.find('.jsc-section-details');
    var $thisVarID = $thisInput.attr('data-var-id');
    var $thisError = $this.find('.extra-error');
    
    if ($thisVarID == '' ) {
      $thisError.addClass('show-error');
      //start: scroll to main section when selection is incomplete
      window.scrollTo({top: divPosition, behavior: 'smooth'});
      //end: scroll to main section when selection is incomplete
    }
    else {
      $thisError.removeClass('show-error');
      countSelectedType += 1;
    }
  });
  // console.log(countSelectedType);
  //end: to calculate selected color

  var $products = [];
  $eachProduct.each(function(){
    var $this = $(this);
    var $thisInput = $this.find('.jsc-section-details');
    var $thisVarID = parseInt($thisInput.attr('data-var-id'));
    var $thisVarAvail =$thisInput.attr('data-var-avail');
    countLoop += 1;
    
    if ($thisVarAvail && countSelectedType ==  $loopLimit ) {
      var $product = {};
      $product['id'] = $thisVarID;
      $product['quantity'] = 1;
      $product['properties'] = $objMain;
      $products.push($product);
    }
  });
  if ($products.length > 0) {
  CartJS.addItems($products,
  {
    "success": function(data, textStatus, jqXHR) {
        location.reload();
    },
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", textStatus);
    }
  });
  }
}
jscLoungewearPrice = () => {
  // console.log('update price');
  var $total_price = 0;
  var $section = $('.loungewear-template').find('.jsc-main-bedbuilder .jsc-section-bb');
  var $price_div = $('.jsc-lw-price-container .lw-price-after-discount');
  var $price_default = $price_div.find('.lw-dummy-price').attr('data-default-price');
  var discountAttr = $('.bedbuilder-template .jsc-builder-discount');
  var discountType = discountAttr.attr('data-disc-type');
  var discountvalue = discountAttr.attr('data-disc-value');

  $section.each(function(){
    var $this_details = $(this).find('.jsc-section-details');
    var $this_price = $this_details.attr('data-price');

    if ($this_price !== '') {
      var $this_price_int = parseInt($this_price);
      $total_price += $this_price_int;
      // console.log($this_price,$this_price_int,$total_price);
    }
    
  });
  var $total_afterDiscount = $total_price * ((100 - parseInt(discountvalue))/100);
  var format_totalPrice = Shopify.formatMoney($total_afterDiscount, $('body').data('money'));
  console.log($total_afterDiscount,$total_price);

  if ($total_price < $price_default ) {
    $price_div.find('.lw-total-price').html('');
    $price_div.find('.lw-dummy-price').show();
  } else {
    $price_div.find('.lw-total-price').html(format_totalPrice);
    $price_div.find('.lw-dummy-price').hide();
  }
  
}
//end: loungewear bundle

externalLinkNewTab = () => {
  var links = document.links;
  // console.log(links, 'links');
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
}

//start: hide product review section when 0 review
hidePDPReview = () => {
  setTimeout(function(){
    var $reviewSection = $('#product-review-section');
    var $emptyState = $('.yotpo-empty-state').length;
    // console.log('$emptyState',$emptyState,$reviewSection);

    if ($emptyState) {
      $reviewSection.parents('.shopify-section--custom-liquid').addClass('d-none');
      $reviewSection.parents('.shopify-section--custom-liquid').hide();
    }
  },1000);
}
//end: hide product review section when 0 review

// start: mobile nav slider
initMobileNavSlider = () => {
  $('.jsc-mobile-nav .jsc-mobile-nav-slider').flickity({
      cellAlign: 'left',
      pageDots: false,
      prevNextButtons: false,
      adaptiveHeight: true,
      freeScroll: true,
      contain: true
  });
}
// end: mobile nav slider

//start: pdp klaviyo star styling
klaviyoStarStyling = () => {
  setTimeout(() => {
    var app_block = $('.product-info .shopify-block.shopify-app-block');
    var app_id = app_block.attr('id');
    var price_block_bundle = $('.jsc-bundle-price-container').parents('.product-info__liquid');
    var price_block_default = $('.product-info__price');
    var star_margin_top = '20px';
    var is_price_exist = false;

    if (price_block_bundle.length > 0 || price_block_default) {
      is_price_exist = true;
    }

    if (app_id.includes('klaviyo') && is_price_exist == true ) {

      if (price_block_bundle.length > 0) {
        price_block_bundle.css({
          display: 'inline-block'
        });
        star_margin_top = '25px';
      }

      if (price_block_default.length > 0) {
        price_block_default.css({
          display: 'inline-block'
        });
      }

      app_block.css({
        display: 'inline-block',
        float: 'right',
        marginTop: star_margin_top
      });
      
    }
    
  }, 500);
  
}
//start: pdp klaviyo star styling

//start: pdp image swap
onloadimgswap = () => {
  var $imgContainer = $('.jsc-product-gallery-new-layout');
  if ($imgContainer.length > 0) {
    var $checkedSwatch = $('.ColorSwatch__Radio:checked');
    var col = $checkedSwatch.val();
    var colHandle = $checkedSwatch.attr('data-value-handle');
    if (!col) { return; }
    var lowercaseCol = col.toLowerCase();
    //start: pdp image gallery
    var product_gallery = $('.jsc-product-gallery-new-layout').find('.product-gallery__media');

    product_gallery.each(function(){
      var $this_alt = $(this).attr('data-colour-tag');
      // console.log($this_alt,lowercaseCol,$(this));
      $(this).addClass('d-none');

      if ($this_alt == colHandle || $this_alt == 'multi-variants') {
        $(this).removeClass('d-none');
      }    
    });
    //end: pdp image gallery

    //start: pdp thumbnail
    // var product_thumbnail = $('.jsc-product-gallery-new-layout').parents('.product-gallery').find('.product-gallery__thumbnail-list-wrapper button');
    var reverse_product_thumbnail = $('.jsc-product-gallery__thumbnail-list .product-gallery__thumbnail').get().reverse();
    var split_variant = $('.jsc-sticky-prod-gallery-desktop').attr('data-split-variant');

    $(reverse_product_thumbnail).each(function(){
      var $this_colour = $(this).attr('data-button-colour');

      if ($this_colour == colHandle ) { // || $this_colour == 'multi-variants'
        // 
        if ($('.jsc-thumbnail-multi-variants').length > 0) {
          $(this).addClass('jsc-extra-thumbnail'); // to hide redundant grid
          $(this).insertAfter('.jsc-thumbnail-multi-variants');
          $(this).removeClass('jsc-extra-thumbnail');
        } else {
          $('.product-gallery__thumbnail-list').prepend($(this));
        }
        
      }
      else {
        if (split_variant && $this_colour != 'multi-variants') {
          $(this).addClass('d-none'); // hide unselected swatch thumbnails
        }
      }
    });

    // $('.jsc-product-gallery__thumbnail-list').flickity({
    //   cellAlign: 'left',
    //   pageDots: false,
    //   prevNextButtons: false,
    //   wrapAround: true,
    //   draggable: true,
    //   contain: false
    // });
    //end: pdp thumbnail
  }
}

onclickVarColor = (e,col) => {
  console.log('selected color',col);
  $(e).siblings('.variant-picker__option-info').find('.jsc-variant-picker').html(col);

  //start: pdp image gallery
  var product_gallery = $('.jsc-product-gallery-new-layout').find('.product-gallery__media');

  product_gallery.each(function(){
    var $this_alt = $(this).attr('data-colour-tag');

    $(this).addClass('d-none');
  
    if ($this_alt == col) {
      $(this).removeClass('d-none');
    } 
    if ($this_alt.includes('multi-variants')) {
      $(this).removeClass('d-none');
    }
  });
  //end: pdp image gallery

  //start: pdp thumbnail
  var $carousel = $('.jsc-product-gallery__thumbnail-list.flickity-enabled').flickity();
  $carousel.flickity('destroy');

  // var product_thumbnail = $('.jsc-product-gallery-new-layout').parents('.product-gallery').find('.product-gallery__thumbnail-list-wrapper button');
  var get_current_col = $('.jsc-selected-var').attr('data-save-colour');
  var reverse_product_thumbnail = $('.jsc-product-gallery__thumbnail-list .product-gallery__thumbnail').get().reverse();
  var split_variant = $('.jsc-sticky-prod-gallery-desktop').attr('data-split-variant');

  if (get_current_col != col) {
    $(reverse_product_thumbnail).each(function(){
      var $this_colour = $(this).attr('data-button-colour');

      if (split_variant && $this_colour != 'multi-variants') {
        $(this).addClass('d-none'); // hide unselected swatch thumbnails
      }
      if ($this_colour == 'multi-variants') {
        $('.product-gallery__thumbnail-list').prepend($(this));
      }
      if ($this_colour == col) {
        $('.product-gallery__thumbnail-list').prepend($(this));
        if (split_variant && $this_colour != 'multi-variants') {
          $(this).removeClass('d-none'); // show selected swatch thumbnails
        }
      }
      
    });
  }
  $('.jsc-selected-var').attr('data-save-colour',col);

  // $('.jsc-product-gallery__thumbnail-list').flickity({
  //   cellAlign: 'left',
  //   pageDots: false,
  //   prevNextButtons: false,
  //   wrapAround: false,
  //   draggable: true,
  //   contain: false
  // });
  //end: pdp thumbnail

}
//end: pdp image swap

//start: close nav drawer
jscCloseNavBar = (e) => {
  $(e).siblings('button').click();
}
//end: close nav drawer

//start: scroll featured collection
onloadScrollSection = () => {
  
  $tab_with_button = $('.jsc-tabs-follow-btn-style');

  if ($tab_with_button.length > 0) {
    
    $(window).scroll(function () {
      var scrollTop = $(window).scrollTop();
      var getBarHeight = $('.shopify-section--announcement-bar').length ? $('.shopify-section--announcement-bar').outerHeight() : 0;
      var getHeaderHeight = $('.shopify-section--header').length ? $('.shopify-section--header').outerHeight() : 0;
      var totalHeight = getBarHeight + getHeaderHeight;

      var the_sections = $('.jsc-featured-collection-section');

      the_sections.each(function () {
        
        var offsetTop;
        var offsetBottom;
        scrollTop = scrollTop + 100;
        var tab = $(this);

        if ($(window).width() <= 768) {
            var mob_nav_title = $('.jsc-side-nav__item-container.jsc-faq-sticky');
            var stickyHeight = mob_nav_title.length ? mob_nav_title.outerHeight() : 0;
            offsetTop = tab.offset().top - getHeaderHeight - stickyHeight;
        } else {
            offsetTop = tab.offset().top - getHeaderHeight;
        }

        offsetBottom = offsetTop + tab.outerHeight();
        //console.log('offsetTop',offsetTop,'offsetBottom',offsetBottom);

        // If scroll position is within this section's range
        if (scrollTop >= offsetTop && scrollTop < offsetBottom) {
        var $current_id = tab.attr('id');
        
        var $tab_children = $tab_with_button.find('.jsc-tabs-div').children();
        $tab_children.each(function(){
          
          var $tab_id = $(this).attr('data-title-handle');

          if ($tab_id == $current_id) {
            $(this).addClass('jsc-sub-nav-tab-active');
          } else {
            $(this).removeClass('jsc-sub-nav-tab-active');
          }
        })

          return false; // Exit each loop once active tab found
        }
      });
      // console.log(scrollTop,totalHeight);
    });
  }
}
//end:

//start: set language class on main wrapper
setStoreLanguageClass = () => {
  var $main = $('#main');
  var $ann_bar = $('#shopify-section-announcement-bar');
  var $header = $('#shopify-section-header');
  var $footer = $('#shopify-section-footer');

  if ($main.length === 0) {
    return;
  }

  var htmlLang = (($('html').attr('lang') || '').toLowerCase()).trim();
  var pathname = (window.location.pathname || '').toLowerCase();
  var routeLang = (($('.jsc-store-routes').attr('data-route') || '').toLowerCase()).trim();
  var isThai = false;

  if (htmlLang.indexOf('th') === 0) {
    isThai = true;
  } else if (pathname.indexOf('/th') === 0 || routeLang.indexOf('/th') === 0) {
    isThai = true;
  }

  $main.removeClass('store-lang-th store-lang-eng');
  $main.addClass(isThai ? 'store-lang-th' : 'store-lang-eng');
  $ann_bar.removeClass('store-lang-th store-lang-eng');
  $ann_bar.addClass(isThai ? 'store-lang-th' : 'store-lang-eng');
  $header.removeClass('store-lang-th store-lang-eng');
  $header.addClass(isThai ? 'store-lang-th' : 'store-lang-eng');
  $footer.removeClass('store-lang-th store-lang-eng');
  $footer.addClass(isThai ? 'store-lang-th' : 'store-lang-eng');
}
//end: set language class on main wrapper

// start: collection filter icon active state
updateJscFilterIconActiveState = () => {
  $('.jsc-show-filter-icons .checkbox-container').each(function() {
    var $container = $(this);
    var isChecked = $container.find('input[type="radio"], input[type="checkbox"]').is(':checked');
    $container.toggleClass('active', isChecked);
  });
}

runJscFilterIconActiveStateSync = () => {
  // Run now, then re-run after potential async facet DOM refresh.
  updateJscFilterIconActiveState();
  window.requestAnimationFrame(function() {
    updateJscFilterIconActiveState();
  });
  setTimeout(function() {
    updateJscFilterIconActiveState();
  }, 120);
};

initJscFilterIconActiveStateObserver = () => {
  if (window.jscFilterIconObserverInitialized || typeof MutationObserver === 'undefined') {
    return;
  }

  window.jscFilterIconObserverInitialized = true;

  var observer = new MutationObserver(function(mutations) {
    var shouldSync = false;

    mutations.forEach(function(mutation) {
      if (shouldSync || mutation.addedNodes.length === 0) {
        return;
      }

      mutation.addedNodes.forEach(function(node) {
        if (shouldSync || node.nodeType !== 1) {
          return;
        }

        var $node = $(node);
        if (
          $node.is('.jsc-show-filter-icons, .jsc-show-filter-icons *') ||
          $node.find('.jsc-show-filter-icons').length > 0
        ) {
          shouldSync = true;
        }
      });
    });

    if (shouldSync) {
      runJscFilterIconActiveStateSync();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
};

$(document).on('change', '.jsc-show-filter-icons .checkbox-container input[type="radio"], .jsc-show-filter-icons .checkbox-container input[type="checkbox"]', function() {
  runJscFilterIconActiveStateSync();
});

$(document).ready(function() {
  runJscFilterIconActiveStateSync();
  initJscFilterIconActiveStateObserver();
});
// end: collection filter icon active state